import React, { useCallback, useState, useEffect, useRef } from "react";
import commentIcon from "../../../../assets/svg/comment.svg";
import vector71Icon from "../../../../assets/svg/Vector 71.svg";
import viewIcon from "../../../../assets/svg/view.svg";
import {
  Form,
  Image,
  Grid,
  Table,
  Icon,
  Button,
  Comment,
  CommentGroup,
  CommentMetadata,
  GridColumn,
  GridRow,

  Segment,
  Divider,
  Header,
  Modal,
  Label,
  ModalActions,
  ModalContent,
  ModalHeader,
  List,
  Message,
  Popup,
  Checkbox,
  Input,
  Dropdown,
} from "semantic-ui-react";
import { useDropzone } from "react-dropzone";
import { useFormik, Field, FieldArray, FormikProvider, getIn } from "formik";
import { Energyform, Form as FormApi, AuditLog } from "../../../../api";

const auditLogController = new AuditLog();
import { useAuth } from "../../../../hooks";
import { PERIODS } from "../../../../utils";
import {
  formatDateView,
  formatDateHourCompleted,
} from "../../../../utils/formatDate";
import { BasicModal } from "../../../Shared";
import { initialValues, validationSchema } from "./EnergyForm.form";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { decrypt, encrypt } from "../../../../utils/cryptoUtils";
import "./SiteForm.scss";
import { useLanguage } from "../../../../contexts";
import { determineEnergyUnits } from "../../../../utils/dataAndFormulas/energyForms";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css"; // Importa el CSS de react-toastify

const MAX_INVOICE_FILES = 20;
const MAX_INVOICE_FILE_SIZE = 10 * 1024 * 1024; // 10 MB, igual que el backend
import { isAdmin, isEditor, isReviewer, isMaster } from "../../../../utils/checkPermission";
import { invoiceCurrencySymbol, formatInvoiceAmount, formatInvoiceQuantity, INVOICE_CURRENCY_BADGE_STYLE } from "../../../../utils/invoiceFormat";
const energyFormController = new Energyform();
const formController = new FormApi();

// Multi-medidor: clave normalizada para agrupar por nombre de medidor sin que
// mayúsculas/espacios generen medidores "distintos" por error de tipeo.
const normalizeMeterKey = (name) => (name || "").trim().toLowerCase();

const PERIOD_NUM_TO_NAME = {
  "01": "January", "1": "January",
  "02": "February", "2": "February",
  "03": "March", "3": "March",
  "04": "April", "4": "April",
  "05": "May", "5": "May",
  "06": "June", "6": "June",
  "07": "July", "7": "July",
  "08": "August", "8": "August",
  "09": "September", "9": "September",
  "10": "October",
  "11": "November",
  "12": "December",
};

export function EnergyForm(props) {
  const {
    onClose,
    onReload,
    energyForm,
    siteSelected,
    year,
    period,
    configFormData,
    unitsRecorded,
    crossMonthRestrictions = {},
  } = props;

  // Debug: verificar que se reciben los props correctamente
  // console.log("🔍 EnergyForm Props:", {
  //   hasEnergyForm: !!energyForm,
  //   hasConfigFormData: !!configFormData,
  //   configFormDataFields: configFormData?.fields?.length || 0,
  //   hasUnitsRecorded: !!unitsRecorded,
  //   unitsRecordedKeys: Object.keys(unitsRecorded || {}).length,
  //   energyForm,
  //   configFormData,
  //   unitsRecorded
  // });

  const { accessToken } = useAuth();
  const [showModalInt, setShowModalInt] = useState(false);
  const [titleModal, setTitleModal] = useState("");
  const [fieldName, setFieldName] = useState("");
  const [showConfirm, setShowConfirm] = useState(false);
  const [listPeriods, setListPeriods] = useState([]);
  const [yearComplete, setYearComplete] = useState(false);

  const [newFiles, setNewFiles] = useState({});

  // Lector de facturas
  const [invoiceLoading, setInvoiceLoading] = useState(false);
  const [invoiceResults, setInvoiceResults] = useState([]);
  const [showInvoiceModal, setShowInvoiceModal] = useState(false);
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [invoicePeriodMismatch, setInvoicePeriodMismatch] = useState(false);
  const [bulkSaveLoading, setBulkSaveLoading] = useState(false);
  const [bulkSaveResults, setBulkSaveResults] = useState(null);
  const [applyWarning, setApplyWarning] = useState(null);
  const [appliedIndexes, setAppliedIndexes] = useState(new Set());
  // Nombre de medidor por fila (_rowId) — solo se pide cuando hay 2+ facturas del mismo período
  const [meterNames, setMeterNames] = useState({});
  // Elección doméstica/producción por fila (_rowId) cuando el energyType detectado
  // tiene ambos campos activos a la vez y no hay forma de saber cuál corresponde
  const [sourceChoices, setSourceChoices] = useState({});
  // Medidores ya usados en el sitio (para el selector, en vez de tipear a mano)
  const [existingMeterNames, setExistingMeterNames] = useState([]);
  const bulkSaveResultsRef = useRef(null);
  const invoiceInputRef = useRef(null);
  const pendingInvoicePeriodRef = useRef(null);

  // Estado para habilitar/deshabilitar edición de unidades (solo admin/master)
  const [unitEditEnabled, setUnitEditEnabled] = useState(false);

  const { user } = useAuth();

  // Verificar si el usuario puede editar unidades
  const canEditUnits = isAdmin(user.role) || isMaster(user.role);
  const isReadOnly = isReviewer(user.role);

  const location = useLocation();
  // const { siteSelected } = location.state || {};

  const { translations, language } = useLanguage();

  const t = (key) => translations[key] || key; // Función para obtener la traducción

  if (!siteSelected) {
    // // Manejo de caso donde no hay datos en state (por ejemplo, acceso directo a la URL)
    // return <div>No se encontraron detalles de producto.</div>;
  }

  const navigate = useNavigate();

  const onOpenCloseModal = () => setShowModalInt((prevState) => !prevState);
  const onOpenCloseConfirm = () => setShowConfirm((prevState) => !prevState);
  const openUpdateSite = (data, name) => {
    setFieldName(name);
    setTitleModal(`${t("comments")} ${data}`);
    setShowModalInt(true);
  };

function setNestedError(obj, path, value) {
     const keys = path.split("."); // ["natural_gas", "unit"]
     let current = obj;
     keys.forEach((key, index) => {
       if (index === keys.length - 1) {
         current[key] = value; // asigna el mensaje de error al último nivel
       } else {
         if (!current[key]) current[key] = {}; // crea objeto si no existe
         current = current[key]; // baja al siguiente nivel
       }
     });
   }

   // Helper function to get approval status styling
   const getApprovalStatusStyle = (approvalStatus, isDisabled = false) => ({
     backgroundColor:
       approvalStatus === "approved" ? "#d4edda" :
       approvalStatus === "rejected" ? "#f8d7da" :
       approvalStatus === "pending" ? "#fff3cd" : "white",
     color:
       approvalStatus === "approved" ? "#155724" :
       approvalStatus === "rejected" ? "#721c24" :
       approvalStatus === "pending" ? "#856404" : "black",
     fontWeight: "bold",
     opacity: isDisabled ? 0.9 : 1
   });

   // Helper function para limpiar el valor 0 cuando se hace focus en el campo
   const handleFocusNumberInput = (e) => {
     const value = e.target.value;
     if (value === "0" || value === 0) {
       e.target.value = "";
     }
   };

   const formik = useFormik({
     initialValues: initialValues(energyForm, period, year, unitsRecorded),
     // validationSchema: validationSchema(),
 
       validate: (values) => {
          const errors = {};
          try {
            validationSchema().validateSync(values, { abortEarly: false });
          } catch (err) {
            if (err.inner && err.inner.length > 0) {
              err.inner.forEach((e) => {
                errors[e.path] = e.message;
                setNestedError(errors, e.path, e.message);
                formik.setFieldTouched(e.path, true, false);
              });
    
              // 🔹 Mostrar toast resumido
              const fields = err.inner
                .map((e) => {
                  if (e.path.includes(".unit"))
                    return `${t("unit")} (${t(e.path.split(".")[0])})`;
                  if (e.path.includes(".value"))
                    return `${t("value")} (${t(e.path.split(".")[0])})`;
                  return t(e.path);
                })
                .join(", ");
              toast.error(`Faltan completar datos: ${t(fields)}`);
    
              // 🔹 Scroll automático al primer error
              // 🔹 Scroll automático al primer error
              const firstErrorPath = err.inner[0]?.path;
              if (firstErrorPath) {
                const fieldId = firstErrorPath.replace(/\./g, "_");
                let fieldEl =
                  document.getElementById(fieldId) ||
                  document.querySelector(`[name="${firstErrorPath}"]`);
    
                if (!fieldEl) {
                  fieldEl = Array.from(
                    document.querySelectorAll("input, select, textarea")
                  ).find(
                    (el) =>
                      el.name?.includes(firstErrorPath) || el.id?.includes(fieldId)
                  );
                }
    
                if (fieldEl) {
                  // Buscar el contenedor con scroll
                  let scrollContainer = fieldEl.parentElement;
                  while (
                    scrollContainer &&
                    scrollContainer !== document.body &&
                    scrollContainer.scrollHeight <= scrollContainer.clientHeight
                  ) {
                    scrollContainer = scrollContainer.parentElement;
                  }
    
                  // Calcular posición
                  const rect = fieldEl.getBoundingClientRect();
                  const offset = 150;
    
                  if (scrollContainer && scrollContainer !== document.body) {
                    const containerRect = scrollContainer.getBoundingClientRect();
                    const scrollTopTarget =
                      scrollContainer.scrollTop +
                      (rect.top - containerRect.top) -
                      offset;
                    scrollContainer.scrollTo({
                      top: scrollTopTarget,
                      behavior: "smooth",
                    });
                  } else {
                    window.scrollTo({
                      top: rect.top + window.scrollY - offset,
                      behavior: "smooth",
                    });
                  }
    
                  fieldEl.focus({ preventScroll: true });
                } else {
                  window.scrollTo({ top: 0, behavior: "smooth" });
                }
              }
            }
          }
          return errors;
        },
    validateOnChange: false,
    onSubmit: async (formValue) => {
      try {
        if (!energyForm) {
          formValue.creator_user = user._id;
          formValue.date = new Date();
          if (user?.site) {
            formValue.site = user.site;
          } else {
            if (siteSelected) {
              formValue.site = siteSelected;
            }
            // else {
            //   // Desencriptar los datos recibidos
            //   if (!energyForm) {
            //     const siteData = decrypt(siteSelected);
            //     formValue.site = siteData;
            //   }
            // }
          }

          // Verificar si ya existe un formulario con el mismo sitio, período y año
          const siteId = formValue.site || siteSelected || user?.site;
          if (siteId && period && year) {
            const existsResponse = await energyFormController.existsEnergyFormByPeriodAndYear(
              accessToken,
              siteId,
              period,
              year
            );
            if (existsResponse?.exist) {
              toast.error("Ya existe un formulario de energía para este sitio, período y año.");
              return;
            }
          }

          // Recorrer el JSON
          for (const clave in newFiles) {
            if (newFiles.hasOwnProperty(clave)) {
              let filesField = await uploadFiles(newFiles[clave]);

              // Combina los archivos nuevos con los existentes
              let finalFilesField = [...formValue[clave].files, ...filesField];

              formValue[clave].files = finalFilesField;
            }
          }
          ///const finalData = removeNullValues(formValue);
          const response = await energyFormController.createEnergyForm(
            accessToken,
            formValue
          );

          if (response.code && response.code === 200) {
            toast.success("Formulario guardado correctamente!.");
            // Enviar email de resumen en background (no bloquea el flujo)
            energyFormController.sendSummaryEmail(accessToken, {
              to: user.email,
              siteName: siteSelected || user?.site || "",
              period: formValue.period,
              year: formValue.year,
              kwh: formValue.electricity_standard_combined?.value,
              cost: formValue.electricity_standard_combined_cost?.value,
            }).catch(() => {});
          } else if (response.code && response.code === 400) {
            toast.error(response.msg || "Error al guardar el formulario");
            return;
          }
        } else {
          // Recorrer el JSON
          for (const clave in newFiles) {
            if (newFiles.hasOwnProperty(clave)) {
              let filesField = await uploadFiles(newFiles[clave]);

              // Combina los archivos nuevos con los existentes
              let finalFilesField = [...formValue[clave].files, ...filesField];

              formValue[clave].files = finalFilesField;
            }
          }

          // Detectar cambios de unidad para auditoría (solo admin/master)
          if (isAdmin(user.role) || isMaster(user.role)) {
            const unitChanges = [];
            for (const fieldName in formValue) {
              if (formValue[fieldName]?.unit !== undefined && energyForm[fieldName]?.unit !== undefined) {
                const newUnit = formValue[fieldName].unit;
                const oldUnit = energyForm[fieldName].unit;
                const defaultUnit = unitsRecorded?.[fieldName] || "";

                // Solo registrar como cambio si:
                // 1. La unidad original existía (no vacía) Y es diferente a la nueva
                // 2. O la unidad original era vacía pero la nueva es diferente del default de unitsRecorded
                //    (significa que el usuario la cambió manualmente)
                const isRealChange = oldUnit && oldUnit !== ""
                  ? oldUnit !== newUnit  // Tenía unidad antes y ahora es diferente
                  : newUnit !== defaultUnit && newUnit !== "";  // No tenía unidad, pero ahora tiene una diferente al default

                if (isRealChange) {
                  unitChanges.push({
                    field: fieldName,
                    oldUnit: oldUnit,
                    newUnit: newUnit,
                    oldValue: energyForm[fieldName].value,
                    newValue: formValue[fieldName].value,
                  });
                }
              }
            }

            // Registrar cambios de unidad en auditoría
            for (const change of unitChanges) {
              try {
                await auditLogController.createAuditLog(accessToken, {
                  documentId: energyForm._id,
                  documentType: "energy",
                  field: change.field,
                  oldValue: { value: change.oldValue, unit: change.oldUnit },
                  newValue: { value: change.newValue, unit: change.newUnit },
                  changeType: change.oldValue !== change.newValue ? "both" : "unit_change",
                  changedBy: user._id,
                  site: energyForm.site,
                  company: energyForm.company,
                  year: energyForm.year,
                  period: energyForm.period,
                  reason: "Corrección de unidad desde formulario de edición",
                });
              } catch (auditError) {
                console.error("Error registrando auditoría:", auditError);
              }
            }

            if (unitChanges.length > 0) {
              toast.info(`${unitChanges.length} cambio(s) de unidad registrado(s) en auditoría`);
            }
          }

          const finalData = removeNullValues(formValue);
          const response2 = await energyFormController.updateEnergyForm(
            accessToken,
            energyForm._id,
            finalData
          );

          if (response2.code && response2.code === 200) {
            toast.success("Formulario guardado correctamente!.");
            // Enviar email de resumen en background (no bloquea el flujo)
            energyFormController.sendSummaryEmail(accessToken, {
              to: user.email,
              siteName: siteSelected || user?.site || "",
              period: formValue.period,
              year: formValue.year,
              kwh: formValue.electricity_standard_combined?.value,
              cost: formValue.electricity_standard_combined_cost?.value,
            }).catch(() => {});
          } else if (response2.code && response2.code === 400) {
            toast.error(response2.msg || "Error al actualizar el formulario");
            return;
          }
        }
        // Retrasar el cierre del modal o el reload para dar tiempo a que la tostada se vea
        setTimeout(() => {
          onReload();
          if (onClose) {
            onClose();
          } else {
            // Después de guardar exitosamente, navegamos hacia atrás
            goBack();
          }
        }, 1000);
      } catch (error) {
        console.error(error);
        if (error?.msg) {
          toast.error(error.msg);
        }
      }
    },
  });

  const uploadFiles = async (filesToUpload, formValue, field) => {
    const formData = new FormData();
    Array.from(filesToUpload).forEach((file) => {
      formData.append("files", file);
    });

    // Luego de preparar los datos, puedes hacer la solicitud POST
    if (filesToUpload.length === 0) {
      //console.log("no hay archivos");
      //setErrorMessage("Por favor, selecciona al menos un archivo.");
      return;
    }

    try {
      // Realizar la solicitud POST al backend
      const response = await energyFormController.uploadFileApi(
        accessToken,
        formData
      );
      if (response.code && response.code === 200) {
        return response.files;
      }
      return [];
    } catch (error) {
      //error
    }
  };

  function removeNullValues(obj) {
    for (const key in obj) {
      if (typeof obj[key] === "object" && obj[key].hasOwnProperty("value")) {
        if (obj[key].value === "" || obj[key].value === null) {
          delete obj[key];
        }
      }
    }
    return obj;
  }

  const goBack = () => {
    navigate(`/admin/data/energyforms`, {
      state: { siteSelected: siteSelected },
    });
  };

  // Lector de facturas — abre modal de carga
  const handleOpenInvoiceInput = (e) => {
    e.preventDefault();
    setShowUploadModal(true);
  };

  // Mapa: energyType detectado por el lector → campos del formulario de esa
  // familia. "domestic"/"production" solo existen para las 3 familias con ese
  // desglose (electricidad, renovables PPA, renovables on-site) — el resto
  // usa "combined" (o el único campo "_total") directo, sin ambigüedad
  // doméstica/producción.
  const ENERGY_TYPE_FIELD_MAP = {
    electricity:       { combined: "electricity_standard_combined", domestic: "electricity_standard_domestic", production: "electricity_standard_production", cost: "electricity_cost_total" },
    renewable_ppa:     { combined: "renewable_energies_ppa_combined", domestic: "renewable_energies_ppa_domestic", production: "renewable_energies_ppa_production", cost: "renewable_energies_ppa_cost" },
    renewable_on_site: { combined: "renewable_energies_on_site_combined", domestic: "renewable_energies_on_site_domestic", production: "renewable_energies_on_site_production" },
    natural_gas:       { combined: "natural_gas_combined", cost: "natural_gas_total_cost" },
    glp:               { combined: "glp_combined", cost: "glp_total_cost" },
    diesel:            { combined: "diesel_combined", cost: "diesel_total_cost", cogeneration: "diesel_cogeneration", productionOperations: "diesel_production_operations", forklifts: "diesel_forklifts" },
    biodiesel:         { combined: "biodiesel_combined", cost: "biodiesel_total_cost", cogeneration: "biodiesel_cogeneration", productionOperations: "biodiesel_production_operations", forklifts: "biodiesel_forklifts" },
    gasoline:          { combined: "gasoline_combined", cost: "gasoline_total_cost", cogeneration: "gasoline_cogeneration", productionOperations: "gasoline_production_operations", forklifts: "gasoline_forklifts" },
    biofuel:           { combined: "biofuel_combined", cost: "biofuel_total_cost", cogeneration: "biofuel_cogeneration", productionOperations: "biofuel_production_operations", forklifts: "biofuel_forklifts" },
    heavy_fuel_oil:    { combined: "heavy_fuel_oil_total", cost: "heavy_fuel_oil_total_cost" },
    light_fuel_oil:    { combined: "light_fuel_oil_total", cost: "light_fuel_oil_total_cost" },
    coal:              { combined: "coal_total", cost: "coal_total_cost" },
    biomass:           { combined: "biomass_total", cost: "biomass_total_cost" },
    steam:             { combined: "steam_total", cost: "steam_total_cost" },
  };

  // Familias que distinguen doméstica/producción además de combinada — mismo
  // trío que Agua (combinada/doméstica/producción): combinada activa → se usa
  // combinada; si no, doméstica+producción activas a la vez → hay que
  // preguntar; si solo una está activa → directo ahí.
  const TRIO_ENERGY_TYPES = new Set(["electricity", "renewable_ppa", "renewable_on_site"]);

  // Familias con 4 sub-usos (combinada + 3 categorías, sin doméstica): igual
  // idea que el trío, pero con cogeneración/producción y operaciones/
  // montacargas en vez de doméstica/producción. Si combinada está activa se
  // usa esa; si no, y hay 2 o 3 sub-usos activos a la vez, hay que preguntar
  // cuál corresponde; si solo uno está activo, directo ahí.
  const QUAD_ENERGY_TYPES = new Set(["diesel", "biodiesel", "gasoline", "biofuel"]);

  // Todos los campos combinados/totales + costo, de las 14 familias — los que
  // admiten desglose por medidor (records[]) — para juntar nombres de
  // medidores ya usados en el sitio, sin importar la familia.
  const ALL_MULTI_METER_FIELDS = Object.values(ENERGY_TYPE_FIELD_MAP)
    .flatMap((map) => [map.combined, map.cost])
    .filter(Boolean);

  // Procesa los archivos (desde input o dropzone)
  const processInvoiceFiles = async (files) => {
    if (!files || files.length === 0) return;
    if (files.length > MAX_INVOICE_FILES) {
      toast.error(t("too_many_invoice_files") || `Se permiten hasta ${MAX_INVOICE_FILES} archivos por carga`);
      return;
    }
    const oversized = files.find((f) => f.size > MAX_INVOICE_FILE_SIZE);
    if (oversized) {
      toast.error(`"${oversized.name}" ${t("file_exceeds_max_size") || "supera el tamaño máximo permitido (10MB)"}`);
      return;
    }
    setInvoiceLoading(true);
    try {
      const formData = new FormData();
      files.forEach(f => formData.append("files", f));
      const result = await energyFormController.readDocument(accessToken, formData);
      if (result.code === 200) {
        // La lectura automática no está disponible en este momento (servicio
        // externo) y el regex tampoco pudo leer nada: no abrimos el preview.
        if (result.aiUnavailable) {
          toast.info(t("invoice_ai_unavailable") || "No pudimos leer la factura automáticamente en este momento. Volvé a intentar en unos minutos.");
          setShowUploadModal(false);
          return;
        }
        const validResults = result.results.filter(r => !r.error && r.period && r.year);
        const uniquePeriods = new Set(validResults.map(r => `${r.period}/${r.year}`));
        setInvoicePeriodMismatch(uniquePeriods.size > 1);
        // _rowId identifica cada fila de forma única: un mismo PDF puede
        // traer varias facturas y compartir "filename" entre varias filas.
        setInvoiceResults(result.results.map((r, i) => ({ ...r, _rowId: `${r.filename}#${i}` })));
        setAppliedIndexes(new Set());
        setShowUploadModal(false);
        setShowInvoiceModal(true);
      } else {
        toast.error(result.msg || t("could_not_read_document"));
      }
    } catch (err) {
      toast.error(err?.msg || err?.message || t("error_processing_invoice"));
    } finally {
      setInvoiceLoading(false);
    }
  };

  // Procesa los archivos seleccionados desde input oculto
  const handleInvoiceFileChange = async (e) => {
    const files = Array.from(e.target.files);
    if (!files.length) return;
    e.target.value = "";
    await processInvoiceFiles(files);
  };

  // Aplica los datos extraídos de una fila al formulario
  const handleUnapplyInvoiceData = (result) => {
    if (!result) return;
    setAppliedIndexes(prev => {
      const next = new Set(prev);
      next.delete(result._rowId);
      return next;
    });
  };

  const handleApplyInvoiceData = (result) => {
    if (!result) return;

    const periodName = result.period ? (PERIOD_NUM_TO_NAME[result.period] || result.period) : null;
    const yearNum = result.year ? parseInt(result.year, 10) : null;

    const target = resolveTargetFields(result.energyType);
    const family = familyOf(result.energyType);

    const applyPeriodAndYear = () => {
      const yearIsChanging = yearNum && yearNum !== formik.values.year;
      if (yearNum) formik.setFieldValue("year", yearNum);
      if (periodName) {
        if (yearIsChanging) {
          pendingInvoicePeriodRef.current = periodName;
        } else if (listPeriods.includes(periodName)) {
          formik.setFieldValue("period", periodName);
        } else {
          toast.warning(`El período ${t(periodName)} ya está cargado para este año.`);
        }
      }
    };

    // Tipo de energía detectado pero el sitio no tiene ese campo activo en su
    // configuración: no hay dónde aplicarla, se bloquea con aviso en vez de
    // escribir en un campo que el formulario ni siquiera muestra.
    if (target.mode === "blocked") {
      toast.warning(
        t("energy_type_field_not_configured")
        || `Este sitio no tiene configurado el campo "${t(target.valueField) || target.valueField}".`
      );
      return;
    }

    // Doméstica o Producción (sin ambigüedad, o ya elegida): campo directo,
    // sin multi-medidor.
    if (target.mode === "direct" || target.mode === "choice") {
      const chosen = target.mode === "choice" ? resolveChosenFields(result._rowId, family) : target;
      if (!chosen) {
        toast.warning(t("energy_type_choice_required") || "Elegí a qué corresponde esta factura antes de aplicar.");
        return;
      }
      if (result.value != null) formik.setFieldValue(`${chosen.valueField}.value`, result.value);
      if (result.cost != null && chosen.costField) formik.setFieldValue(`${chosen.costField}.value`, result.cost);

      applyPeriodAndYear();
      setAppliedIndexes(prev => new Set(prev).add(result._rowId));
      toast.success(t("invoice_data_applied"));
      return;
    }

    // mode === "combined": comportamiento existente, con multi-medidor.
    const periodKey = periodName && yearNum ? `${yearNum}-${periodName}` : null;

    // ¿Ya hay otra factura aplicada para el mismo período Y el mismo tipo de
    // energía? Dos facturas del mismo mes pero de tipos distintos (ej.
    // electricidad + gas natural) no compiten entre sí — van a campos separados.
    const conflicting = periodKey ? invoiceResults.find(r =>
      r._rowId !== result._rowId &&
      appliedIndexes.has(r._rowId) &&
      r.period && r.year &&
      familyOf(r.energyType) === family &&
      `${parseInt(r.year, 10)}-${PERIOD_NUM_TO_NAME[String(r.period)] || r.period}` === periodKey
    ) : null;

    // Nombre del medidor: el que escribió el usuario; si no, el número de
    // medidor que trae la factura; si no, el nombre del archivo (así varias
    // facturas del mismo mes se cargan sin tener que escribir nada)
    const meterName = (meterNames[result._rowId] || result.meter || result.filename || "").trim();
    if (conflicting && !meterName) {
      toast.warning(t("meter_name_required") || "Ingresá un nombre de medidor para agregar este registro.");
      return;
    }

    // Agrega (o inicia) el desglose por medidor de un campo, y recalcula su total.
    // Idempotencia: si ya hay un registro con el mismo sourceHash (mismo
    // archivo ya aplicado antes), no se duplica. El primer valor de un
    // período (antes de que exista records[]) también guarda su sourceHash
    // como campo simple — si no se hiciera, esa primera factura no tendría
    // forma de detectarse como duplicada si se reaplica más adelante como medidor.
    let skippedDuplicate = false;
    const addAsMeterRecord = (fieldName, value) => {
      if (value == null || !fieldName) return;
      const current = formik.values[fieldName] || {};
      const defaultMeterLabel = t("meter_default") !== "meter_default" ? t("meter_default") : "Medidor 1";
      const prevRecords = current.records?.length
        ? current.records
        : (current.value != null
            ? [{
                meterName: current.filename || defaultMeterLabel,
                value: current.value,
                source: current.sourceHash ? "invoice_reader" : "manual",
                filename: current.filename,
                sourceHash: current.sourceHash,
              }]
            : []);

      if (result.sourceHash && prevRecords.some((r) => r.sourceHash === result.sourceHash)) {
        skippedDuplicate = true;
        return;
      }

      const newRecords = [...prevRecords, { meterName, value, source: "invoice_reader", filename: result.filename, sourceHash: result.sourceHash, addedBy: user?._id }];
      formik.setFieldValue(`${fieldName}.records`, newRecords);
      formik.setFieldValue(`${fieldName}.value`, newRecords.reduce((s, r) => s + (r.value || 0), 0));
    };

    if (conflicting) {
      addAsMeterRecord(target.valueField, result.value);
      addAsMeterRecord(target.costField, result.cost);
      if (skippedDuplicate) {
        toast.warning(t("meter_record_already_applied") || "Esta factura ya se había agregado como registro — no se duplicó.");
        return;
      }
    } else {
      if (result.value != null) {
        formik.setFieldValue(`${target.valueField}.value`, result.value);
        formik.setFieldValue(`${target.valueField}.sourceHash`, result.sourceHash);
        formik.setFieldValue(`${target.valueField}.filename`, result.filename);
      }
      if (result.cost != null && target.costField) {
        formik.setFieldValue(`${target.costField}.value`, result.cost);
        formik.setFieldValue(`${target.costField}.sourceHash`, result.sourceHash);
        formik.setFieldValue(`${target.costField}.filename`, result.filename);
      }
    }

    applyPeriodAndYear();

    // A diferencia de antes, no se desaplica la factura en conflicto: ambas
    // quedan aplicadas porque ahora se suman como registros de medidores distintos.
    setAppliedIndexes(prev => new Set(prev).add(result._rowId));
    toast.success(t("invoice_data_applied"));
  };

  // Guarda o actualiza los resultados aplicados agrupados por período+año
  // Acepta una lista opcional para no depender del estado async de appliedIndexes
  const handleSaveAllInvoiceData = async (overrideList) => {
    const source = Array.isArray(overrideList)
      ? overrideList
      : invoiceResults.filter(r => !r.error && r.period && r.year && appliedIndexes.has(r._rowId));
    const validResults = source.filter(r => r.period && r.year);
    if (!validResults.length) {
      toast.warning(t("no_valid_results_to_save") || "No hay resultados válidos para guardar.");
      return;
    }

    setBulkSaveLoading(true);
    setBulkSaveResults(null);

    const siteId = siteSelected || user?.site;
    const summary = { saved: [], skipped: [], errors: [] };

    // Agrupar por período+año para combinar múltiples facturas del mismo mes
    const groups = new Map();
    for (const result of validResults) {
      const periodName = PERIOD_NUM_TO_NAME[String(result.period)] || result.period;
      const yearNum    = parseInt(result.year, 10);
      const key = `${yearNum}-${periodName}`;
      if (!groups.has(key)) groups.set(key, { periodName, yearNum, results: [] });
      groups.get(key).results.push(result);
    }

    // Arma el desglose por medidor de un grupo para un campo (value/cost), a
    // partir de los resultados de este lote + lo que ya hubiera guardado.
    // Idempotencia: descarta resultados cuyo sourceHash ya esté entre los
    // registros existentes (mismo archivo ya guardado — reintento).
    const buildRecords = (results, key, existingRecords) => {
      const existingHashes = new Set((existingRecords || []).map((r) => r.sourceHash).filter(Boolean));
      const own = results
        .filter(r => r[key] != null && !(r.sourceHash && existingHashes.has(r.sourceHash)))
        .map((r, i) => ({
          meterName: (meterNames[r._rowId] || r.meter || r.filename || `${t("meter") !== "meter" ? t("meter") : "Medidor"} ${i + 1}`).trim(),
          value: r[key],
          source: "invoice_reader",
          filename: r.filename,
          sourceHash: r.sourceHash,
          addedBy: user?._id,
        }));
      return [...(existingRecords || []), ...own];
    };

    // Arma los campos a guardar para los resultados de una misma familia
    // (energyType) dentro de un mismo grupo período+año.
    // Energy.findByIdAndUpdate con un objeto parcial hace $set sobre el
    // subdocumento COMPLETO del campo — reemplaza todo lo que tenía antes
    // (unit, code, approvalStatus, reviews, files), no solo "value"/"records".
    // Por eso se preserva unit/code/approvalStatus/reviews/files de cada
    // campo que se escribe, a partir del documento existente.
    const buildEnergyFieldsForFamily = (results, family, existingDoc) => {
      const target = resolveTargetFields(family);
      const energyFields = {};

      // Bloqueada (campo no activo en el sitio): no debería llegar acá porque
      // handleApplyInvoiceData ya la frena al aplicar, pero por las dudas no
      // se guarda nada.
      if (target.mode === "blocked") return energyFields;

      const preserved = (fieldName) => {
        const prev = existingDoc?.[fieldName];
        return {
          ...(prev?.code !== undefined ? { code: prev.code } : {}),
          unit: prev?.unit || unitsRecorded?.[fieldName] || "",
          ...(prev?.approvalStatus !== undefined ? { approvalStatus: prev.approvalStatus } : {}),
          ...(prev?.reviews !== undefined ? { reviews: prev.reviews } : {}),
          ...(prev?.files !== undefined ? { files: prev.files } : {}),
        };
      };

      if (target.mode !== "combined") {
        // Doméstica / Producción: sin multi-medidor (esos campos no tienen
        // desglose por medidor). Si el modo es "choice", cada resultado puede
        // apuntar a un campo distinto según lo elegido al aplicarlo — última
        // carga gana por campo, como siempre fue doméstica/producción antes
        // de que existiera multi-medidor.
        for (const r of results) {
          const chosen = target.mode === "choice" ? resolveChosenFields(r._rowId, family) : target;
          if (!chosen) continue; // sin elección hecha, se omite (no debería pasar si se validó al aplicar)
          if (r.value != null) energyFields[chosen.valueField] = { ...preserved(chosen.valueField), value: r.value };
          if (r.cost != null && chosen.costField) energyFields[chosen.costField] = { ...preserved(chosen.costField), value: r.cost };
        }
        return energyFields;
      }

      // Si un campo ya tenía un valor simple guardado (sin records[] — la
      // primera factura de un período), lo convierte en el primer registro
      // antes de promoverlo a multi-medidor, arrastrando su sourceHash para
      // que la deduplicación lo siga reconociendo si se reaplica más tarde.
      const defaultMeterLabel = t("meter_default") !== "meter_default" ? t("meter_default") : "Medidor 1";
      const synthesizeRecords = (fieldName) => {
        if (!fieldName) return [];
        const prev = existingDoc?.[fieldName];
        if (prev?.records?.length) return prev.records;
        if (prev?.value != null) {
          return [{
            meterName: prev.filename || defaultMeterLabel,
            value: prev.value,
            source: prev.sourceHash ? "invoice_reader" : "manual",
            filename: prev.filename,
            sourceHash: prev.sourceHash,
          }];
        }
        return [];
      };

      // Si hay un solo resultado en el grupo y el período no tenía medidores
      // previos, se guarda como valor simple (comportamiento de siempre).
      // Si hay 2+ resultados, o ya había un desglose por medidor guardado,
      // se arma/actualiza el array de registros y el total se recalcula.
      const existingValueRecords = synthesizeRecords(target.valueField);
      const existingCostRecords  = synthesizeRecords(target.costField);

      const needsValueRecords = results.length > 1 || existingValueRecords.length > 0;
      const needsCostRecords  = !!target.costField && (results.length > 1 || existingCostRecords.length > 0);
      const last = results[results.length - 1];

      if (needsValueRecords) {
        const allRecords = buildRecords(results, "value", existingValueRecords);
        if (allRecords.length > 0) {
          energyFields[target.valueField] = {
            ...preserved(target.valueField),
            records: allRecords,
            value: allRecords.reduce((s, r) => s + (r.value || 0), 0),
          };
        }
      } else if (last.value != null) {
        energyFields[target.valueField] = { ...preserved(target.valueField), value: last.value, sourceHash: last.sourceHash, filename: last.filename };
      }

      if (needsCostRecords) {
        const allRecords = buildRecords(results, "cost", existingCostRecords);
        if (allRecords.length > 0) {
          energyFields[target.costField] = {
            ...preserved(target.costField),
            records: allRecords,
            value: allRecords.reduce((s, r) => s + (r.value || 0), 0),
          };
        }
      } else if (target.costField && last.cost != null) {
        energyFields[target.costField] = { ...preserved(target.costField), value: last.cost, sourceHash: last.sourceHash, filename: last.filename };
      }

      return energyFields;
    };

    for (const { periodName, yearNum, results } of groups.values()) {
      try {
        const existsResponse = await energyFormController.existsEnergyFormByPeriodAndYear(
          accessToken, siteId, periodName, yearNum
        );

        // getEnergy devuelve el documento crudo (no envuelto en { energyForm })
        let existingDoc = null;
        if (existsResponse?.exist) {
          existingDoc = await energyFormController.getEnergyForm(accessToken, existsResponse.id);
        }

        // Un mismo grupo período+año puede mezclar facturas de distintos
        // tipos de energía (ej. electricidad + gas natural del mismo mes) —
        // se procesan por separado, por familia, y se combinan en el mismo payload.
        const resultsByFamily = new Map();
        for (const r of results) {
          const fam = familyOf(r.energyType);
          if (!resultsByFamily.has(fam)) resultsByFamily.set(fam, []);
          resultsByFamily.get(fam).push(r);
        }

        const energyFields = {};
        for (const [fam, famResults] of resultsByFamily) {
          Object.assign(energyFields, buildEnergyFieldsForFamily(famResults, fam, existingDoc));
        }

        if (existsResponse?.exist) {
          await energyFormController.updateEnergyForm(accessToken, existsResponse.id, energyFields);
        } else {
          const payload = initialValues(null, periodName, yearNum, unitsRecorded);
          payload.creator_user = user._id;
          payload.date = new Date();
          payload.site = siteId;
          Object.assign(payload, energyFields);
          await energyFormController.createEnergyForm(accessToken, payload);
        }

        results.forEach(r => summary.saved.push({ period: periodName, year: yearNum, filename: r.filename }));
      } catch (err) {
        results.forEach(r => summary.errors.push({ period: periodName, year: yearNum, filename: r.filename, msg: err?.msg || err?.message }));
      }
    }

    setBulkSaveLoading(false);
    setBulkSaveResults(summary);
    if (summary.saved.length > 0) {
      onReload?.();
    }
    setTimeout(() => {
      const el = bulkSaveResultsRef.current;
      if (!el) return;
      const scrollContainer =
        el.closest(".scrolling.content") ||
        el.closest(".modal .content") ||
        el.closest(".content");
      if (scrollContainer) {
        scrollContainer.scrollTo({ top: scrollContainer.scrollHeight, behavior: "smooth" });
      } else {
        el.scrollIntoView({ behavior: "smooth", block: "nearest" });
      }
    }, 100);
  };

  // Generar una lista de años (por ejemplo, del 2000 al 2024)
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 50 }, (_, i) => currentYear - i);

  useEffect(() => {
    (async () => {
      try {
        // console.log(siteSelected)
        const response =
          await energyFormController.getPeriodsEnergyFormsBySiteAndYear(
            accessToken,
            siteSelected,
            formik.values.year
          );
        const periods = PERIODS.map((item) => item);
        const availablePeriods = periods
          .filter((period) => !response.periods.includes(period))
          .map((period) => period);

        setListPeriods(availablePeriods);

        // Detectar si todos los meses del año están completos
        if (availablePeriods.length === 0) {
          setYearComplete(true);
        } else {
          setYearComplete(false);
        }

        // Aplicar periodo pendiente desde lectura de documento
        if (pendingInvoicePeriodRef.current) {
          const pending = pendingInvoicePeriodRef.current;
          pendingInvoicePeriodRef.current = null;
          if (availablePeriods.includes(pending)) {
            formik.setFieldValue("period", pending);
          } else {
            toast.warning(`El período ${t(pending)} ya está cargado para el año ${formik.values.year}.`);
          }
        }
      } catch (error) {
        console.error(error);
        setListPeriods([]);
        setYearComplete(false);
        pendingInvoicePeriodRef.current = null;
      }
    })();
  }, [formik.values.year]);

  // Medidores ya usados en el sitio — para ofrecerlos en el selector del
  // lector de facturas en vez de que el usuario tenga que tipear el nombre.
  useEffect(() => {
    if (!showInvoiceModal) return;
    const siteId = siteSelected || user?.site;
    if (!siteId) return;
    (async () => {
      try {
        const years = [...new Set([
          formik.values.year,
          formik.values.year - 1,
        ].filter(Boolean))];
        const responses = await Promise.all(
          years.map((y) => energyFormController.getEnergyFormsBySiteAndYear(accessToken, siteId, y).catch(() => null))
        );
        const seen = new Map();
        responses.forEach((response) => {
          (response?.energyForms || []).forEach((form) => {
            ALL_MULTI_METER_FIELDS.flatMap((fieldName) => form[fieldName]?.records || []).forEach((r) => {
              const key = normalizeMeterKey(r.meterName);
              if (key && !seen.has(key)) seen.set(key, r.meterName.trim());
            });
          });
        });
        setExistingMeterNames(Array.from(seen.values()).sort());
      } catch (error) {
        console.error(error);
        setExistingMeterNames([]);
      }
    })();
  }, [showInvoiceModal, formik.values.year, siteSelected]);

  function findActiveFieldByName(nameToFind) {
    if (
      configFormData &&
      configFormData.fields &&
      configFormData.fields.length > 0
    ) {
      return configFormData.fields.some(
        (field) => field.name === nameToFind && field.active
      );
    }
    return true;
  }

  // Lector de facturas — a qué campo aplicar según qué campos estén activos
  // para el sitio, para las 3 familias con desglose doméstica/producción.
  //   mode "combined" → aplica a combinada (con multi-medidor).
  //   mode "direct"   → solo doméstica o solo producción está activa: aplica
  //     directo ahí, sin multi-medidor (esos campos no tienen desglose).
  //   mode "choice"   → doméstica y producción están activas a la vez (y
  //     combinada no): hay que preguntarle al usuario a cuál corresponde.
  //     choiceOptions trae los sub-usos activos entre los que elegir.
  function resolveTrioTargetFields(energyType) {
    const map = ENERGY_TYPE_FIELD_MAP[energyType];
    if (findActiveFieldByName(map.combined)) {
      return { mode: "combined", valueField: map.combined, costField: map.cost };
    }
    const domesticActive = findActiveFieldByName(map.domestic);
    const productionActive = findActiveFieldByName(map.production);
    if (domesticActive && productionActive) {
      return { mode: "choice", choiceOptions: [
        { key: "domestic", field: map.domestic },
        { key: "production", field: map.production },
      ] };
    }
    if (domesticActive) {
      return { mode: "direct", valueField: map.domestic, costField: undefined };
    }
    if (productionActive) {
      return { mode: "direct", valueField: map.production, costField: undefined };
    }
    // Ninguno de los tres está activo (configuración atípica) — no rompemos
    // el comportamiento de siempre, se sigue asumiendo combinada.
    return { mode: "combined", valueField: map.combined, costField: map.cost };
  }

  // Igual que el trío, pero para las 4 familias con cogeneración/producción y
  // operaciones/montacargas en vez de doméstica/producción (diésel,
  // biodiésel, gasolina, biocombustible). Combinada activa → se usa esa; si
  // no, y hay 2 o 3 sub-usos activos a la vez, hay que preguntar cuál
  // corresponde; si solo uno está activo, directo ahí.
  function resolveQuadTargetFields(energyType) {
    const map = ENERGY_TYPE_FIELD_MAP[energyType];
    if (findActiveFieldByName(map.combined)) {
      return { mode: "combined", valueField: map.combined, costField: map.cost };
    }
    const activeSubUses = [
      { key: "cogeneration", field: map.cogeneration },
      { key: "productionOperations", field: map.productionOperations },
      { key: "forklifts", field: map.forklifts },
    ].filter((s) => findActiveFieldByName(s.field));

    if (activeSubUses.length === 1) {
      return { mode: "direct", valueField: activeSubUses[0].field, costField: undefined };
    }
    if (activeSubUses.length > 1) {
      return { mode: "choice", choiceOptions: activeSubUses };
    }
    // Ninguno de los 4 está activo (configuración atípica) — no rompemos el
    // comportamiento de siempre, se sigue asumiendo combinada.
    return { mode: "combined", valueField: map.combined, costField: map.cost };
  }

  // Familias sin desglose (un solo campo combinado/total, con costo pareado
  // salvo renovables on-site que no tiene). Si el sitio no tiene ese campo
  // activo, se bloquea — no hay dónde aplicar la factura.
  function resolveSimpleEnergyTargetFields(energyType) {
    const map = ENERGY_TYPE_FIELD_MAP[energyType];
    return findActiveFieldByName(map.combined)
      ? { mode: "combined", valueField: map.combined, costField: map.cost }
      : { mode: "blocked", valueField: map.combined };
  }

  // Despacha según el energyType detectado por el lector para esa factura
  // puntual. Default "electricity" — cualquier resultado sin energyType (o
  // con un valor no reconocido) se comporta exactamente igual que antes de
  // que existiera este despacho.
  function resolveTargetFields(energyType) {
    const type = ENERGY_TYPE_FIELD_MAP[energyType] ? energyType : "electricity";
    if (TRIO_ENERGY_TYPES.has(type)) return resolveTrioTargetFields(type);
    if (QUAD_ENERGY_TYPES.has(type)) return resolveQuadTargetFields(type);
    return resolveSimpleEnergyTargetFields(type);
  }

  // Cada energyType es su propia familia — no compiten entre sí por período:
  // dos facturas del mismo mes pero de energyType distinto (ej. electricidad
  // + gas natural) van a campos separados.
  function familyOf(energyType) {
    return ENERGY_TYPE_FIELD_MAP[energyType] ? energyType : "electricity";
  }

  // choice guarda la key del sub-uso elegido ("domestic"/"production" para el
  // trío, o "cogeneration"/"productionOperations"/"forklifts" para el cuarteto)
  // — mapea directo a su campo en ENERGY_TYPE_FIELD_MAP.
  function resolveChosenFields(rowId, family) {
    const choice = sourceChoices[rowId];
    if (!choice) return null;
    const fieldName = ENERGY_TYPE_FIELD_MAP[family]?.[choice];
    return fieldName ? { valueField: fieldName, costField: undefined } : null;
  }

  return (
    <>
    <Form className="energy-form" onSubmit={formik.handleSubmit}>
      {energyForm ? (
        <div style={{ display: "flex", gap: "10px", flexWrap: "wrap", marginBottom: "12px" }}>
          <span style={{
            display: "inline-flex", alignItems: "center", gap: "6px",
            backgroundColor: "#EDEDED", color: "#555",
            borderRadius: "999px", padding: "5px 14px",
            fontSize: "0.85rem", fontWeight: 600,
          }}>
            <Icon name="calendar alternate outline" style={{ margin: 0 }} />
            {energyForm.date ? formatDateView(energyForm.date) : "-"}
          </span>
          <span style={{
            display: "inline-flex", alignItems: "center", gap: "6px",
            backgroundColor: "#EDEDED", color: "#555",
            borderRadius: "999px", padding: "5px 14px",
            fontSize: "0.85rem", fontWeight: 600,
          }}>
            <Icon name="user outline" style={{ margin: 0 }} />
            {energyForm.creator_user
              ? energyForm.creator_user.lastname
                ? energyForm.creator_user.lastname + " " + energyForm.creator_user.firstname
                : energyForm.creator_user.email
              : "-"}
          </span>
        </div>
      ) : null}
      {!energyForm ? (
        <>
          <Grid columns={2} divided>
            <GridRow style={{ display: "flex", gap: "20px" }}>
              {/* Año */}
              <GridColumn style={{ flex: 1 }}>
                <div
                // style={{ display: "flex", flexDirection: "column", gap: "4px" }}
                >
                  <div
                  //style={{ display: "flex", alignItems: "center", gap: "8px" }}
                  >
                    <label style={{ minWidth: "80px", fontWeight: 600 }}>
                      <span style={{ color: "red" }}>*</span> {t("year")}
                    </label>
                    <Form.Dropdown
                      placeholder={t("select")}
                      options={years.map((year) => ({
                        key: year,
                        text: year,
                        value: year,
                      }))}
                      selection
                      onChange={(_, data) =>
                        formik.setFieldValue("year", data.value)
                      }
                      value={formik.values.year}
                      error={!!formik.errors.year && !!formik.touched.year}
                      style={{ flex: 1 }}
                      name="year"
                    />
                  </div>
                  <div
                    style={{
                      color: "red",
                      fontSize: "0.8em",
                      minHeight: "1.2em",
                    }}
                  >
                    {formik.touched.year && formik.errors.year}
                  </div>
                </div>
              </GridColumn>

              {/* Periodo */}
              <GridColumn style={{ flex: 1 }}>
                <div
                // style={{ display: "flex", flexDirection: "column", gap: "4px" }}
                >
                  <div
                  //style={{ display: "flex", alignItems: "center", gap: "8px" }}
                  >
                    <label style={{ minWidth: "80px", fontWeight: 600 }}>
                      <span style={{ color: "red" }}>*</span>
                      {t("period")}
                    </label>
                    <Form.Dropdown
                      placeholder={t("select")}
                      options={listPeriods.map((period) => ({
                        key: period,
                        text: t(period),
                        value: period,
                      }))}
                      selection
                      value={formik.values.period}
                      onChange={(_, data) => {
                        // Actualiza el valor
                        formik.setFieldValue("period", data.value);
                        // Marca el campo como tocado (opcional)
                        formik.setFieldTouched("period", true, false);
                        // Borra el error si hay uno
                        formik.setFieldError("period", undefined);
                      }}
                      error={!!formik.errors.period && !!formik.touched.period}
                      style={{ flex: 1 }}
                      name="period"
                      disabled={yearComplete}
                    />
                  </div>
                  <div
                    style={{
                      color: "red",
                      fontSize: "0.8em",
                      minHeight: "1.2em",
                    }}
                  >
                    {formik.touched.period && formik.errors.period}
                  </div>
                </div>
              </GridColumn>
            </GridRow>
          </Grid>
          {/* Mensaje de advertencia cuando el año está completo */}
          {yearComplete && !energyForm && (
            <div
              style={{
                position: "fixed",
                top: "80px",
                left: "50%",
                transform: "translateX(-50%)",
                width: "90%",
                maxWidth: "800px",
                zIndex: 99999,
                backgroundColor: "#fffef5",
                border: "1px solid #e8e8e8",
                borderRadius: "6px",
                padding: "15px",
                boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                textAlign: "center"
              }}
            >
              <div style={{ fontSize: "1.1em", fontWeight: "600", color: "#666", marginBottom: "8px" }}>
                Meses del año completo
              </div>
              <p style={{ fontSize: "0.95em", margin: "0", color: "#555", lineHeight: "1.5" }}>
                Todos los periodos del año <strong>{formik.values.year}</strong> ya están cargados.
                <br />
                Por favor, seleccione otro año para crear un nuevo formulario.
                <br />
                Si desea editar un periodo existente, cierre esta ventana y seleccione el formulario a editar.
              </p>
            </div>
          )}
        </>
      ) : null}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "0.5rem" }}>
        {/* Botón para habilitar edición de unidades (solo admin/master en modo edición) */}
        {canEditUnits && energyForm ? (
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <Button
              type="button"
              color={unitEditEnabled ? "orange" : "grey"}
              size="small"
              icon
              labelPosition="left"
              onClick={() => setUnitEditEnabled(!unitEditEnabled)}
            >
              <Icon name={unitEditEnabled ? "unlock" : "lock"} />
              {unitEditEnabled
                ? (t("disable_unit_edit") || "Deshabilitar edición de unidades")
                : (t("enable_unit_edit") || "Habilitar edición de unidades")
              }
            </Button>
            {unitEditEnabled && (
              <Message warning size="tiny" style={{ margin: 0, padding: "8px 12px" }}>
                <Icon name="warning sign" />
                {t("unit_edit_warning") || "Los cambios de unidad se registrarán en auditoría"}
              </Message>
            )}
          </div>
        ) : <div />}

        <Popup
          content={t("read_invoice_tooltip")}
          trigger={
            <Form.Button
              type="button"
              color="teal"
              size="small"
              icon="file alternate"
              loading={invoiceLoading}
              onClick={handleOpenInvoiceInput}
            />
          }
        />
        <input
          ref={invoiceInputRef}
          type="file"
          accept=".pdf,.jpg,.jpeg,.png,.webp,.csv,.xlsx,.xls,.txt"
          multiple
          style={{ display: "none" }}
          onChange={handleInvoiceFileChange}
        />
      </div>

      <Table className="energy-form-table" unstackable>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell width="1">{t("code")}</Table.HeaderCell>
            <Table.HeaderCell width="6">{t("concept")}</Table.HeaderCell>
            <Table.HeaderCell width="2">{t("value")}</Table.HeaderCell>
            <Table.HeaderCell width="2">
              {t("unit")}
              {unitEditEnabled && (
                <Icon name="edit" size="small" style={{ marginLeft: "5px", color: "#f57c00" }} />
              )}
            </Table.HeaderCell>
            <Table.HeaderCell width="2">{t("state")}</Table.HeaderCell>
            <Table.HeaderCell>{t("actions")}</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          <Table.Row className="energy-form-section-header">
            <Table.Cell colSpan={7}>{t("electrical_energy")}</Table.Cell>
          </Table.Row>
          {findActiveFieldByName("electricity_standard_combined") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.electricity_standard_combined.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("electricity_standard_combined")}</label>
              </Table.Cell>
              <Table.Cell>
                {/* CÓDIGO ANTERIOR - Sin deshabilitación por exclusividad mutua
                <Form.Input
                  type="number"
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  name="electricity_standard_combined.value"
                  value={formik.values.electricity_standard_combined.value}
                  error={formik.errors.electricity_standard_combined?.value}
                />
                */}
                {/* NUEVO CÓDIGO - Con deshabilitación si domestic o production tienen valor */}
                <Form.Input
                  type="number"
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  name="electricity_standard_combined.value"
                  value={formik.values.electricity_standard_combined.value}
                  error={formik.errors.electricity_standard_combined?.value}
                  disabled={
                    (formik.values.electricity_standard_domestic?.value > 0) ||
                    (formik.values.electricity_standard_production?.value > 0) ||
                    crossMonthRestrictions.electricity_standard_combined
                  }
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.electricity_standard_combined?.unit &&
                    formik.touched.electricity_standard_combined?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.electricity_standard_combined.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineEnergyUnits("electricity_standard_combined").map(
                      (ds) => {
                        return {
                          key: ds.key,
                          text: ds.name,
                          value: ds.value,
                        };
                      }
                    )}
                    selection
                    disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "electricity_standard_combined.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "electricity_standard_combined.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "electricity_standard_combined.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.electricity_standard_combined.unit}
                    error={
                      !!formik.errors.electricity_standard_combined?.unit &&
                      !!formik.touched.electricity_standard_combined?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.electricity_standard_combined?.unit &&
                        formik.touched.electricity_standard_combined?.unit
                          ? "red"
                          : undefined,
                    }}
                     name="electricity_standard_combined.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>

              <Table.Cell>
                <Form.Dropdown
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: 'green', empty: true, circular: true }
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: 'yellow', empty: true, circular: true }
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: 'red', empty: true, circular: true }
                    },
                  ]}
                  selection
                  disabled={isEditor(user.role)}
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      `electricity_standard_combined.approvalStatus`,
                      data.value
                    )
                  }
                  value={formik.values.electricity_standard_combined.approvalStatus}
                  error={formik.errors.electricity_standard_combined?.approvalStatus}
                  style={getApprovalStatusStyle(formik.values.electricity_standard_combined.approvalStatus, isEditor(user.role))}
                />
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      size="small"
                      color="teal"  type="button"
                      onClick={() => {
                        openUpdateSite(
                          t("electricity_standard_combined"),
                          "electricity_standard_combined"
                        );
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"electricity_standard_combined"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
            {findActiveFieldByName("electricity_standard_domestic") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.electricity_standard_domestic.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("electricity_standard_domestic")}</label>
              </Table.Cell>
              <Table.Cell>
                {/* CÓDIGO ANTERIOR - Sin deshabilitación por exclusividad mutua
                <Form.Input
                  type="number"
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  name="electricity_standard_domestic.value"
                  value={formik.values.electricity_standard_domestic.value}
                  error={formik.errors.electricity_standard_domestic?.value}
                />
                */}
                {/* NUEVO CÓDIGO - Con deshabilitación si combined tiene valor */}
                <Form.Input
                  type="number"
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  name="electricity_standard_domestic.value"
                  value={formik.values.electricity_standard_domestic.value}
                  error={formik.errors.electricity_standard_domestic?.value}
                  disabled={
                    formik.values.electricity_standard_combined?.value > 0 ||
                    crossMonthRestrictions.electricity_standard_domestic
                  }
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.electricity_standard_domestic?.unit &&
                    formik.touched.electricity_standard_domestic?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.electricity_standard_domestic.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineEnergyUnits("electricity_standard_domestic").map(
                      (ds) => {
                        return {
                          key: ds.key,
                          text: ds.name,
                          value: ds.value,
                        };
                      }
                    )}
                    selection
                    disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "electricity_standard_domestic.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "electricity_standard_domestic.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "electricity_standard_domestic.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.electricity_standard_domestic.unit}
                    error={
                      !!formik.errors.electricity_standard_domestic?.unit &&
                      !!formik.touched.electricity_standard_domestic?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.electricity_standard_domestic?.unit &&
                        formik.touched.electricity_standard_domestic?.unit
                          ? "red"
                          : undefined,
                    }}
                     name="electricity_standard_domestic.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>

              <Table.Cell>
                <Form.Dropdown
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: 'green', empty: true, circular: true }
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: 'yellow', empty: true, circular: true }
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: 'red', empty: true, circular: true }
                    },
                  ]}
                  selection
                  disabled={isEditor(user.role)}
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      `electricity_standard_domestic.approvalStatus`,
                      data.value
                    )
                  }
                  value={formik.values.electricity_standard_domestic.approvalStatus}
                  error={formik.errors.electricity_standard_domestic?.approvalStatus}
                  style={getApprovalStatusStyle(formik.values.electricity_standard_domestic.approvalStatus, isEditor(user.role))}
                />
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      size="small"
                      color="teal"  type="button"
                      onClick={() => {
                        openUpdateSite(
                          t("electricity_standard_domestic"),
                          "electricity_standard_domestic"
                        );
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"electricity_standard_domestic"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
              {findActiveFieldByName("electricity_standard_production") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.electricity_standard_production.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("electricity_standard_production")}</label>
              </Table.Cell>
              <Table.Cell>
                {/* CÓDIGO ANTERIOR - Sin deshabilitación por exclusividad mutua
                <Form.Input
                  type="number"
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  name="electricity_standard_production.value"
                  value={formik.values.electricity_standard_production.value}
                  error={formik.errors.electricity_standard_production?.value}
                />
                */}
                {/* NUEVO CÓDIGO - Con deshabilitación si combined tiene valor */}
                <Form.Input
                  type="number"
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  name="electricity_standard_production.value"
                  value={formik.values.electricity_standard_production.value}
                  error={formik.errors.electricity_standard_production?.value}
                  disabled={
                    formik.values.electricity_standard_combined?.value > 0 ||
                    crossMonthRestrictions.electricity_standard_production
                  }
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.electricity_standard_production?.unit &&
                    formik.touched.electricity_standard_production?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.electricity_standard_production.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineEnergyUnits("electricity_standard_production").map(
                      (ds) => {
                        return {
                          key: ds.key,
                          text: ds.name,
                          value: ds.value,
                        };
                      }
                    )}
                    selection
                    disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "electricity_standard_production.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "electricity_standard_production.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "electricity_standard_production.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.electricity_standard_production.unit}
                    error={
                      !!formik.errors.electricity_standard_production?.unit &&
                      !!formik.touched.electricity_standard_production?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.electricity_standard_production?.unit &&
                        formik.touched.electricity_standard_production?.unit
                          ? "red"
                          : undefined,
                    }}
                          name="electricity_standard_production.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>

              <Table.Cell>
                <Form.Dropdown
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: 'green', empty: true, circular: true }
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: 'yellow', empty: true, circular: true }
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: 'red', empty: true, circular: true }
                    },
                  ]}
                  selection
                  disabled={isEditor(user.role)}
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      `electricity_standard_production.approvalStatus`,
                      data.value
                    )
                  }
                  value={formik.values.electricity_standard_production.approvalStatus}
                  error={formik.errors.electricity_standard_production?.approvalStatus}
                  style={getApprovalStatusStyle(formik.values.electricity_standard_production.approvalStatus, isEditor(user.role))}
                />
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      size="small"
                      color="teal"  type="button"
                      onClick={() => {
                        openUpdateSite(
                          t("electricity_standard_production"),
                          "electricity_standard_production"
                        );
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"electricity_standard_production"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
                  {findActiveFieldByName("electricity_cost_total") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.electricity_cost_total.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("electricity_cost_total")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  name="electricity_cost_total.value"
                  value={formik.values.electricity_cost_total.value}
                  error={formik.errors.electricity_cost_total?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.electricity_cost_total?.unit &&
                    formik.touched.electricity_cost_total?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.electricity_cost_total.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineEnergyUnits("electricity_cost_total").map(
                      (ds) => {
                        return {
                          key: ds.key,
                          text: ds.name,
                          value: ds.value,
                        };
                      }
                    )}
                    selection
                    disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "electricity_cost_total.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "electricity_cost_total.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "electricity_cost_total.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.electricity_cost_total.unit}
                    error={
                      !!formik.errors.electricity_cost_total?.unit &&
                      !!formik.touched.electricity_cost_total?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.electricity_cost_total?.unit &&
                        formik.touched.electricity_cost_total?.unit
                          ? "red"
                          : undefined,
                    }}
                                          name="electricity_cost_total.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>

              <Table.Cell>
                <Form.Dropdown
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: 'green', empty: true, circular: true }
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: 'yellow', empty: true, circular: true }
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: 'red', empty: true, circular: true }
                    },
                  ]}
                  selection
                  disabled={isEditor(user.role)}
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      `electricity_cost_total.approvalStatus`,
                      data.value
                    )
                  }
                  value={formik.values.electricity_cost_total.approvalStatus}
                  error={formik.errors.electricity_cost_total?.approvalStatus}
                  style={getApprovalStatusStyle(formik.values.electricity_cost_total.approvalStatus, isEditor(user.role))}
                />
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      size="small"
                      color="teal"  type="button"
                      onClick={() => {
                        openUpdateSite(
                          t("electricity_cost_total"),
                          "electricity_cost_total"
                        );
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"electricity_cost_total"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
                  {findActiveFieldByName("renewable_energies_ppa_combined") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.renewable_energies_ppa_combined.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("renewable_energies_ppa_combined")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  name="renewable_energies_ppa_combined.value"
                  value={formik.values.renewable_energies_ppa_combined.value}
                  error={formik.errors.renewable_energies_ppa_combined?.value}
                  disabled={
                    (formik.values.renewable_energies_ppa_domestic?.value > 0) ||
                    (formik.values.renewable_energies_ppa_production?.value > 0) ||
                    crossMonthRestrictions.renewable_energies_ppa_combined
                  }
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.renewable_energies_ppa_combined?.unit &&
                    formik.touched.renewable_energies_ppa_combined?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.renewable_energies_ppa_combined.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineEnergyUnits("renewable_energies_ppa_combined").map(
                      (ds) => {
                        return {
                          key: ds.key,
                          text: ds.name,
                          value: ds.value,
                        };
                      }
                    )}
                    selection
                    disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "renewable_energies_ppa_combined.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "renewable_energies_ppa_combined.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "renewable_energies_ppa_combined.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.renewable_energies_ppa_combined.unit}
                    error={
                      !!formik.errors.renewable_energies_ppa_combined?.unit &&
                      !!formik.touched.renewable_energies_ppa_combined?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.renewable_energies_ppa_combined?.unit &&
                        formik.touched.renewable_energies_ppa_combined?.unit
                          ? "red"
                          : undefined,
                    }}
                          name="renewable_energies_ppa_combined.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>

              <Table.Cell>
                <Form.Dropdown
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: 'green', empty: true, circular: true }
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: 'yellow', empty: true, circular: true }
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: 'red', empty: true, circular: true }
                    },
                  ]}
                  selection
                  disabled={isEditor(user.role)}
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      `renewable_energies_ppa_combined.approvalStatus`,
                      data.value
                    )
                  }
                  value={formik.values.renewable_energies_ppa_combined.approvalStatus}
                  error={formik.errors.renewable_energies_ppa_combined?.approvalStatus}
                  style={getApprovalStatusStyle(formik.values.renewable_energies_ppa_combined.approvalStatus, isEditor(user.role))}
                />
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      size="small"
                      color="teal"  type="button"
                      onClick={() => {
                        openUpdateSite(
                          t("renewable_energies_ppa_combined"),
                          "renewable_energies_ppa_combined"
                        );
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"renewable_energies_ppa_combined"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
                 {findActiveFieldByName("renewable_energies_ppa_domestic") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.renewable_energies_ppa_domestic.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("renewable_energies_ppa_domestic")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  name="renewable_energies_ppa_domestic.value"
                  value={formik.values.renewable_energies_ppa_domestic.value}
                  error={formik.errors.renewable_energies_ppa_domestic?.value}
                  disabled={
                    formik.values.renewable_energies_ppa_combined?.value > 0 ||
                    crossMonthRestrictions.renewable_energies_ppa_domestic
                  }
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.renewable_energies_ppa_domestic?.unit &&
                    formik.touched.renewable_energies_ppa_domestic?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.renewable_energies_ppa_domestic.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineEnergyUnits("renewable_energies_ppa_domestic").map(
                      (ds) => {
                        return {
                          key: ds.key,
                          text: ds.name,
                          value: ds.value,
                        };
                      }
                    )}
                    selection
                    disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "renewable_energies_ppa_domestic.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "renewable_energies_ppa_domestic.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "renewable_energies_ppa_domestic.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.renewable_energies_ppa_domestic.unit}
                    error={
                      !!formik.errors.renewable_energies_ppa_domestic?.unit &&
                      !!formik.touched.renewable_energies_ppa_domestic?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.renewable_energies_ppa_domestic?.unit &&
                        formik.touched.renewable_energies_ppa_domestic?.unit
                          ? "red"
                          : undefined,
                    }}
                     name="renewable_energies_ppa_domestic.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>

              <Table.Cell>
                <Form.Dropdown
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: 'green', empty: true, circular: true }
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: 'yellow', empty: true, circular: true }
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: 'red', empty: true, circular: true }
                    },
                  ]}
                  selection
                  disabled={isEditor(user.role)}
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      `renewable_energies_ppa_domestic.approvalStatus`,
                      data.value
                    )
                  }
                  value={formik.values.renewable_energies_ppa_domestic.approvalStatus}
                  error={formik.errors.renewable_energies_ppa_domestic?.approvalStatus}
                  style={getApprovalStatusStyle(formik.values.renewable_energies_ppa_domestic.approvalStatus, isEditor(user.role))}
                />
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      size="small"
                      color="teal"  type="button"
                      onClick={() => {
                        openUpdateSite(
                          t("renewable_energies_ppa_domestic"),
                          "renewable_energies_ppa_domestic"
                        );
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"renewable_energies_ppa_domestic"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}        {findActiveFieldByName("renewable_energies_ppa_production") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.renewable_energies_ppa_production.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("renewable_energies_ppa_production")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  name="renewable_energies_ppa_production.value"
                  value={formik.values.renewable_energies_ppa_production.value}
                  error={formik.errors.renewable_energies_ppa_production?.value}
                  disabled={
                    formik.values.renewable_energies_ppa_combined?.value > 0 ||
                    crossMonthRestrictions.renewable_energies_ppa_production
                  }
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.renewable_energies_ppa_production?.unit &&
                    formik.touched.renewable_energies_ppa_production?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.renewable_energies_ppa_production.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineEnergyUnits("renewable_energies_ppa_production").map(
                      (ds) => {
                        return {
                          key: ds.key,
                          text: ds.name,
                          value: ds.value,
                        };
                      }
                    )}
                    selection
                    disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "renewable_energies_ppa_production.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "renewable_energies_ppa_production.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "renewable_energies_ppa_production.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.renewable_energies_ppa_production.unit}
                    error={
                      !!formik.errors.renewable_energies_ppa_production?.unit &&
                      !!formik.touched.renewable_energies_ppa_production?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.renewable_energies_ppa_production?.unit &&
                        formik.touched.renewable_energies_ppa_production?.unit
                          ? "red"
                          : undefined,
                    }}
                       name="renewable_energies_ppa_production.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>

              <Table.Cell>
                <Form.Dropdown
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: 'green', empty: true, circular: true }
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: 'yellow', empty: true, circular: true }
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: 'red', empty: true, circular: true }
                    },
                  ]}
                  selection
                  disabled={isEditor(user.role)}
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      `renewable_energies_ppa_production.approvalStatus`,
                      data.value
                    )
                  }
                  value={formik.values.renewable_energies_ppa_production.approvalStatus}
                  error={formik.errors.renewable_energies_ppa_production?.approvalStatus}
                  style={getApprovalStatusStyle(formik.values.renewable_energies_ppa_production.approvalStatus, isEditor(user.role))}
                />
                {/* {formik.values.renewable_energies_ppa_production.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      size="small"
                      color="teal"  type="button"
                      onClick={() => {
                        openUpdateSite(
                          t("renewable_energies_ppa_production"),
                          "renewable_energies_ppa_production"
                        );
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"renewable_energies_ppa_production"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}        {findActiveFieldByName("renewable_energies_ppa_cost") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.renewable_energies_ppa_cost.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("renewable_energies_ppa_cost")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  name="renewable_energies_ppa_cost.value"
                  value={formik.values.renewable_energies_ppa_cost.value}
                  error={formik.errors.renewable_energies_ppa_cost?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.renewable_energies_ppa_cost?.unit &&
                    formik.touched.renewable_energies_ppa_cost?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.renewable_energies_ppa_cost.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineEnergyUnits("renewable_energies_ppa_cost").map(
                      (ds) => {
                        return {
                          key: ds.key,
                          text: ds.name,
                          value: ds.value,
                        };
                      }
                    )}
                    selection
                    disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "renewable_energies_ppa_cost.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "renewable_energies_ppa_cost.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "renewable_energies_ppa_cost.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.renewable_energies_ppa_cost.unit}
                    error={
                      !!formik.errors.renewable_energies_ppa_cost?.unit &&
                      !!formik.touched.renewable_energies_ppa_cost?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.renewable_energies_ppa_cost?.unit &&
                        formik.touched.renewable_energies_ppa_cost?.unit
                          ? "red"
                          : undefined,
                    }}
                    name="renewable_energies_ppa_cost.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>

              <Table.Cell>
                <Form.Dropdown
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: 'green', empty: true, circular: true }
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: 'yellow', empty: true, circular: true }
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: 'red', empty: true, circular: true }
                    },
                  ]}
                  selection
                  disabled={isEditor(user.role)}
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      `renewable_energies_ppa_cost.approvalStatus`,
                      data.value
                    )
                  }
                  value={formik.values.renewable_energies_ppa_cost.approvalStatus}
                  error={formik.errors.renewable_energies_ppa_cost?.approvalStatus}
                  style={getApprovalStatusStyle(formik.values.renewable_energies_ppa_cost.approvalStatus, isEditor(user.role))}
                />
                {/* {formik.values.renewable_energies_ppa_cost.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      size="small"
                      color="teal"  type="button"
                      onClick={() => {
                        openUpdateSite(
                          t("renewable_energies_ppa_cost"),
                          "renewable_energies_ppa_cost"
                        );
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"renewable_energies_ppa_cost"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}        {findActiveFieldByName("renewable_energies_on_site_combined") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.renewable_energies_on_site_combined.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("renewable_energies_on_site_combined")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  name="renewable_energies_on_site_combined.value"
                  value={formik.values.renewable_energies_on_site_combined.value}
                  error={formik.errors.renewable_energies_on_site_combined?.value}
                  disabled={
                    (formik.values.renewable_energies_on_site_domestic?.value > 0) ||
                    (formik.values.renewable_energies_on_site_production?.value > 0) ||
                    crossMonthRestrictions.renewable_energies_on_site_combined
                  }
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.renewable_energies_on_site_combined?.unit &&
                    formik.touched.renewable_energies_on_site_combined?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.renewable_energies_on_site_combined.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineEnergyUnits("renewable_energies_on_site_combined").map(
                      (ds) => {
                        return {
                          key: ds.key,
                          text: ds.name,
                          value: ds.value,
                        };
                      }
                    )}
                    selection
                    disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "renewable_energies_on_site_combined.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "renewable_energies_on_site_combined.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "renewable_energies_on_site_combined.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.renewable_energies_on_site_combined.unit}
                    error={
                      !!formik.errors.renewable_energies_on_site_combined?.unit &&
                      !!formik.touched.renewable_energies_on_site_combined?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.renewable_energies_on_site_combined?.unit &&
                        formik.touched.renewable_energies_on_site_combined?.unit
                          ? "red"
                          : undefined,
                    }}
                     name="renewable_energies_on_site_combined.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>

              <Table.Cell>
                <Form.Dropdown
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: 'green', empty: true, circular: true }
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: 'yellow', empty: true, circular: true }
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: 'red', empty: true, circular: true }
                    },
                  ]}
                  selection
                  disabled={isEditor(user.role)}
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      `renewable_energies_on_site_combined.approvalStatus`,
                      data.value
                    )
                  }
                  value={formik.values.renewable_energies_on_site_combined.approvalStatus}
                  error={formik.errors.renewable_energies_on_site_combined?.approvalStatus}
                  style={getApprovalStatusStyle(formik.values.renewable_energies_on_site_combined.approvalStatus, isEditor(user.role))}
                />
                {/* {formik.values.renewable_energies_on_site_combined.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      size="small"
                      color="teal"  type="button"
                      onClick={() => {
                        openUpdateSite(
                          t("renewable_energies_on_site_combined"),
                          "renewable_energies_on_site_combined"
                        );
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"renewable_energies_on_site_combined"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
               {findActiveFieldByName("irec_certificates") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.irec_certificates.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("irec_certificates")}</label>
              </Table.Cell>
              <Table.Cell>
                {/* CÓDIGO ANTERIOR - Sin deshabilitación por exclusividad mutua
                <Form.Input
                  type="number"
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  name="irec_certificates.value"
                  value={formik.values.irec_certificates.value}
                  error={formik.errors.irec_certificates?.value}
                />
                */}
                {/* NUEVO CÓDIGO - Con deshabilitación si domestic o production tienen valor */}
                <Form.Input
                  type="number"
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  name="irec_certificates.value"
                  value={formik.values.irec_certificates.value}
                  error={formik.errors.irec_certificates?.value}
                  disabled={
                    (formik.values.electricity_standard_domestic?.value > 0) ||
                    (formik.values.electricity_standard_production?.value > 0) ||
                    crossMonthRestrictions.electricity_standard_combined
                  }
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.irec_certificates?.unit &&
                    formik.touched.irec_certificates?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.irec_certificates.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineEnergyUnits("irec_certificates").map(
                      (ds) => {
                        return {
                          key: ds.key,
                          text: ds.name,
                          value: ds.value,
                        };
                      }
                    )}
                    selection
                    disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "irec_certificates.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "irec_certificates.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "irec_certificates.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.irec_certificates.unit}
                    error={
                      !!formik.errors.irec_certificates?.unit &&
                      !!formik.touched.irec_certificates?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.irec_certificates?.unit &&
                        formik.touched.irec_certificates?.unit
                          ? "red"
                          : undefined,
                    }}
                     name="irec_certificates.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>

              <Table.Cell>
                <Form.Dropdown
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: 'green', empty: true, circular: true }
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: 'yellow', empty: true, circular: true }
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: 'red', empty: true, circular: true }
                    },
                  ]}
                  selection
                  disabled={isEditor(user.role)}
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      `irec_certificates.approvalStatus`,
                      data.value
                    )
                  }
                  value={formik.values.irec_certificates.approvalStatus}
                  error={formik.errors.irec_certificates?.approvalStatus}
                  style={getApprovalStatusStyle(formik.values.irec_certificates.approvalStatus, isEditor(user.role))}
                />
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      size="small"
                      color="teal"  type="button"
                      onClick={() => {
                        openUpdateSite(
                          t("irec_certificates"),
                          "irec_certificates"
                        );
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"irec_certificates"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
          <Table.Row className="energy-form-section-header">
            <Table.Cell colSpan={7}>{t("gaseous_fuels")}</Table.Cell>
          </Table.Row>
          
                  {findActiveFieldByName("renewable_energies_on_site_domestic") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.renewable_energies_on_site_domestic.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("renewable_energies_on_site_domestic")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  name="renewable_energies_on_site_domestic.value"
                  value={formik.values.renewable_energies_on_site_domestic.value}
                  error={formik.errors.renewable_energies_on_site_domestic?.value}
                  disabled={
                    formik.values.renewable_energies_on_site_combined?.value > 0 ||
                    crossMonthRestrictions.renewable_energies_on_site_domestic
                  }
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.renewable_energies_on_site_domestic?.unit &&
                    formik.touched.renewable_energies_on_site_domestic?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.renewable_energies_on_site_domestic.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineEnergyUnits("renewable_energies_on_site_domestic").map(
                      (ds) => {
                        return {
                          key: ds.key,
                          text: ds.name,
                          value: ds.value,
                        };
                      }
                    )}
                    selection
                    disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "renewable_energies_on_site_domestic.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "renewable_energies_on_site_domestic.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "renewable_energies_on_site_domestic.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.renewable_energies_on_site_domestic.unit}
                    error={
                      !!formik.errors.renewable_energies_on_site_domestic?.unit &&
                      !!formik.touched.renewable_energies_on_site_domestic?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.renewable_energies_on_site_domestic?.unit &&
                        formik.touched.renewable_energies_on_site_domestic?.unit
                          ? "red"
                          : undefined,
                    }}
                       name="renewable_energies_on_site_domestic.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>

              <Table.Cell>
                <Form.Dropdown
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: 'green', empty: true, circular: true }
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: 'yellow', empty: true, circular: true }
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: 'red', empty: true, circular: true }
                    },
                  ]}
                  selection
                  disabled={isEditor(user.role)}
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      `renewable_energies_on_site_domestic.approvalStatus`,
                      data.value
                    )
                  }
                  value={formik.values.renewable_energies_on_site_domestic.approvalStatus}
                  error={formik.errors.renewable_energies_on_site_domestic?.approvalStatus}
                  style={getApprovalStatusStyle(formik.values.renewable_energies_on_site_domestic.approvalStatus, isEditor(user.role))}
                />
                {/* {formik.values.renewable_energies_on_site_domestic.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      size="small"
                      color="teal"  type="button"
                      onClick={() => {
                        openUpdateSite(
                          t("renewable_energies_on_site_domestic"),
                          "renewable_energies_on_site_domestic"
                        );
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"renewable_energies_on_site_domestic"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}        {findActiveFieldByName("renewable_energies_on_site_production") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.renewable_energies_on_site_production.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("renewable_energies_on_site_production")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  name="renewable_energies_on_site_production.value"
                  value={formik.values.renewable_energies_on_site_production.value}
                  error={formik.errors.renewable_energies_on_site_production?.value}
                  disabled={
                    formik.values.renewable_energies_on_site_combined?.value > 0 ||
                    crossMonthRestrictions.renewable_energies_on_site_production
                  }
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.renewable_energies_on_site_production?.unit &&
                    formik.touched.renewable_energies_on_site_production?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.renewable_energies_on_site_production.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineEnergyUnits("renewable_energies_on_site_production").map(
                      (ds) => {
                        return {
                          key: ds.key,
                          text: ds.name,
                          value: ds.value,
                        };
                      }
                    )}
                    selection
                    disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "renewable_energies_on_site_production.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "renewable_energies_on_site_production.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "renewable_energies_on_site_production.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.renewable_energies_on_site_production.unit}
                    error={
                      !!formik.errors.renewable_energies_on_site_production?.unit &&
                      !!formik.touched.renewable_energies_on_site_production?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.renewable_energies_on_site_production?.unit &&
                        formik.touched.renewable_energies_on_site_production?.unit
                          ? "red"
                          : undefined,
                    }}
                    name="renewable_energies_on_site_production.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>

              <Table.Cell>
                <Form.Dropdown
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: 'green', empty: true, circular: true }
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: 'yellow', empty: true, circular: true }
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: 'red', empty: true, circular: true }
                    },
                  ]}
                  selection
                  disabled={isEditor(user.role)}
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      `renewable_energies_on_site_production.approvalStatus`,
                      data.value
                    )
                  }
                  value={formik.values.renewable_energies_on_site_production.approvalStatus}
                  error={formik.errors.renewable_energies_on_site_production?.approvalStatus}
                  style={getApprovalStatusStyle(formik.values.renewable_energies_on_site_production.approvalStatus, isEditor(user.role))}
                />
                {/* {formik.values.renewable_energies_on_site_production.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      size="small"
                      color="teal"  type="button"
                      onClick={() => {
                        openUpdateSite(
                          t("renewable_energies_on_site_production"),
                          "renewable_energies_on_site_production"
                        );
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"renewable_energies_on_site_production"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}        {findActiveFieldByName("renewable_energies_on_site_maintenance_and_amortization") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.renewable_energies_on_site_maintenance_and_amortization.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("renewable_energies_on_site_maintenance_and_amortization")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  name="renewable_energies_on_site_maintenance_and_amortization.value"
                  value={formik.values.renewable_energies_on_site_maintenance_and_amortization.value}
                  error={formik.errors.renewable_energies_on_site_maintenance_and_amortization?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.renewable_energies_on_site_maintenance_and_amortization?.unit &&
                    formik.touched.renewable_energies_on_site_maintenance_and_amortization?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.renewable_energies_on_site_maintenance_and_amortization.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineEnergyUnits("renewable_energies_on_site_maintenance_and_amortization").map(
                      (ds) => {
                        return {
                          key: ds.key,
                          text: ds.name,
                          value: ds.value,
                        };
                      }
                    )}
                    selection
                    disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "renewable_energies_on_site_maintenance_and_amortization.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "renewable_energies_on_site_maintenance_and_amortization.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "renewable_energies_on_site_maintenance_and_amortization.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.renewable_energies_on_site_maintenance_and_amortization.unit}
                    error={
                      !!formik.errors.renewable_energies_on_site_maintenance_and_amortization?.unit &&
                      !!formik.touched.renewable_energies_on_site_maintenance_and_amortization?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.renewable_energies_on_site_maintenance_and_amortization?.unit &&
                        formik.touched.renewable_energies_on_site_maintenance_and_amortization?.unit
                          ? "red"
                          : undefined,
                    }}
                       name="renewable_energies_on_site_maintenance_and_amortization.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>

              <Table.Cell>
                <Form.Dropdown
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: 'green', empty: true, circular: true }
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: 'yellow', empty: true, circular: true }
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: 'red', empty: true, circular: true }
                    },
                  ]}
                  selection
                  disabled={isEditor(user.role)}
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      `renewable_energies_on_site_maintenance_and_amortization.approvalStatus`,
                      data.value
                    )
                  }
                  value={formik.values.renewable_energies_on_site_maintenance_and_amortization.approvalStatus}
                  error={formik.errors.renewable_energies_on_site_maintenance_and_amortization?.approvalStatus}
                  style={getApprovalStatusStyle(formik.values.renewable_energies_on_site_maintenance_and_amortization.approvalStatus, isEditor(user.role))}
                />
                {/* {formik.values.renewable_energies_on_site_maintenance_and_amortization.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      size="small"
                      color="teal"  type="button"
                      onClick={() => {
                        openUpdateSite(
                          t("renewable_energies_on_site_maintenance_and_amortization"),
                          "renewable_energies_on_site_maintenance_and_amortization"
                        );
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"renewable_energies_on_site_maintenance_and_amortization"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
         

                  {findActiveFieldByName("natural_gas_combined") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.natural_gas_combined.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("natural_gas_combined")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  name="natural_gas_combined.value"
                  value={formik.values.natural_gas_combined.value}
                  error={formik.errors.natural_gas_combined?.value}
                  disabled={
                    (formik.values.natural_gas_production_operations?.value > 0) ||
                    (formik.values.natural_gas_domestic?.value > 0) ||
                    crossMonthRestrictions.natural_gas_combined
                  }
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.natural_gas_combined?.unit &&
                    formik.touched.natural_gas_combined?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.natural_gas_combined.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineEnergyUnits("natural_gas_combined").map(
                      (ds) => {
                        return {
                          key: ds.key,
                          text: ds.name,
                          value: ds.value,
                        };
                      }
                    )}
                    selection
                    disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "natural_gas_combined.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "natural_gas_combined.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "natural_gas_combined.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.natural_gas_combined.unit}
                    error={
                      !!formik.errors.natural_gas_combined?.unit &&
                      !!formik.touched.natural_gas_combined?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.natural_gas_combined?.unit &&
                        formik.touched.natural_gas_combined?.unit
                          ? "red"
                          : undefined,
                    }}
                     name="natural_gas_combined.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>

              <Table.Cell>
                <Form.Dropdown
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: 'green', empty: true, circular: true }
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: 'yellow', empty: true, circular: true }
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: 'red', empty: true, circular: true }
                    },
                  ]}
                  selection
                  disabled={isEditor(user.role)}
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      `natural_gas_combined.approvalStatus`,
                      data.value
                    )
                  }
                  value={formik.values.natural_gas_combined.approvalStatus}
                  error={formik.errors.natural_gas_combined?.approvalStatus}
                  style={getApprovalStatusStyle(formik.values.natural_gas_combined.approvalStatus, isEditor(user.role))}
                />
                {/* {formik.values.natural_gas_combined.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      size="small"
                      color="teal"  type="button"
                      onClick={() => {
                        openUpdateSite(
                          t("natural_gas_combined"),
                          "natural_gas_combined"
                        );
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"natural_gas_combined"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}        {findActiveFieldByName("natural_gas_cogeneration") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.natural_gas_cogeneration.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("natural_gas_cogeneration")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  name="natural_gas_cogeneration.value"
                  value={formik.values.natural_gas_cogeneration.value}
                  error={formik.errors.natural_gas_cogeneration?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.natural_gas_cogeneration?.unit &&
                    formik.touched.natural_gas_cogeneration?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.natural_gas_cogeneration.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineEnergyUnits("natural_gas_cogeneration").map(
                      (ds) => {
                        return {
                          key: ds.key,
                          text: ds.name,
                          value: ds.value,
                        };
                      }
                    )}
                    selection
                    disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "natural_gas_cogeneration.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "natural_gas_cogeneration.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "natural_gas_cogeneration.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.natural_gas_cogeneration.unit}
                    error={
                      !!formik.errors.natural_gas_cogeneration?.unit &&
                      !!formik.touched.natural_gas_cogeneration?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.natural_gas_cogeneration?.unit &&
                        formik.touched.natural_gas_cogeneration?.unit
                          ? "red"
                          : undefined,
                    }}
                      name="natural_gas_cogeneration.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>

              <Table.Cell>
                <Form.Dropdown
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: 'green', empty: true, circular: true }
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: 'yellow', empty: true, circular: true }
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: 'red', empty: true, circular: true }
                    },
                  ]}
                  selection
                  disabled={isEditor(user.role)}
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      `natural_gas_cogeneration.approvalStatus`,
                      data.value
                    )
                  }
                  value={formik.values.natural_gas_cogeneration.approvalStatus}
                  error={formik.errors.natural_gas_cogeneration?.approvalStatus}
                  style={getApprovalStatusStyle(formik.values.natural_gas_cogeneration.approvalStatus, isEditor(user.role))}
                />
                {/* {formik.values.natural_gas_cogeneration.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      size="small"
                      color="teal"  type="button"
                      onClick={() => {
                        openUpdateSite(
                          t("natural_gas_cogeneration"),
                          "natural_gas_cogeneration"
                        );
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"natural_gas_cogeneration"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}        {findActiveFieldByName("natural_gas_production_operations") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.natural_gas_production_operations.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("natural_gas_production_operations")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  name="natural_gas_production_operations.value"
                  value={formik.values.natural_gas_production_operations.value}
                  error={formik.errors.natural_gas_production_operations?.value}
                  disabled={
                    formik.values.natural_gas_combined?.value > 0 ||
                    crossMonthRestrictions.natural_gas_production_operations
                  }
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.natural_gas_production_operations?.unit &&
                    formik.touched.natural_gas_production_operations?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.natural_gas_production_operations.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineEnergyUnits("natural_gas_production_operations").map(
                      (ds) => {
                        return {
                          key: ds.key,
                          text: ds.name,
                          value: ds.value,
                        };
                      }
                    )}
                    selection
                    disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "natural_gas_production_operations.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "natural_gas_production_operations.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "natural_gas_production_operations.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.natural_gas_production_operations.unit}
                    error={
                      !!formik.errors.natural_gas_production_operations?.unit &&
                      !!formik.touched.natural_gas_production_operations?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.natural_gas_production_operations?.unit &&
                        formik.touched.natural_gas_production_operations?.unit
                          ? "red"
                          : undefined,
                    }}
                        name="natural_gas_production_operations.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>

              <Table.Cell>
                <Form.Dropdown
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: 'green', empty: true, circular: true }
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: 'yellow', empty: true, circular: true }
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: 'red', empty: true, circular: true }
                    },
                  ]}
                  selection
                  disabled={isEditor(user.role)}
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      `natural_gas_production_operations.approvalStatus`,
                      data.value
                    )
                  }
                  value={formik.values.natural_gas_production_operations.approvalStatus}
                  error={formik.errors.natural_gas_production_operations?.approvalStatus}
                  style={getApprovalStatusStyle(formik.values.natural_gas_production_operations.approvalStatus, isEditor(user.role))}
                />
                {/* {formik.values.natural_gas_production_operations.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      size="small"
                      color="teal"  type="button"
                      onClick={() => {
                        openUpdateSite(
                          t("natural_gas_production_operations"),
                          "natural_gas_production_operations"
                        );
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"natural_gas_production_operations"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}        {findActiveFieldByName("natural_gas_domestic") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.natural_gas_domestic.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("natural_gas_domestic")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  name="natural_gas_domestic.value"
                  value={formik.values.natural_gas_domestic.value}
                  error={formik.errors.natural_gas_domestic?.value}
                  disabled={
                    formik.values.natural_gas_combined?.value > 0 ||
                    crossMonthRestrictions.natural_gas_domestic
                  }
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.natural_gas_domestic?.unit &&
                    formik.touched.natural_gas_domestic?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.natural_gas_domestic.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineEnergyUnits("natural_gas_domestic").map(
                      (ds) => {
                        return {
                          key: ds.key,
                          text: ds.name,
                          value: ds.value,
                        };
                      }
                    )}
                    selection
                      disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "natural_gas_domestic.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "natural_gas_domestic.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "natural_gas_domestic.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.natural_gas_domestic.unit}
                    error={
                      !!formik.errors.natural_gas_domestic?.unit &&
                      !!formik.touched.natural_gas_domestic?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.natural_gas_domestic?.unit &&
                        formik.touched.natural_gas_domestic?.unit
                          ? "red"
                          : undefined,
                    }}
                         name="natural_gas_domestic.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>

              <Table.Cell>
                <Form.Dropdown
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: 'green', empty: true, circular: true }
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: 'yellow', empty: true, circular: true }
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: 'red', empty: true, circular: true }
                    },
                  ]}
                  selection
                  disabled={isEditor(user.role)}
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      `natural_gas_domestic.approvalStatus`,
                      data.value
                    )
                  }
                  value={formik.values.natural_gas_domestic.approvalStatus}
                  error={formik.errors.natural_gas_domestic?.approvalStatus}
                  style={getApprovalStatusStyle(formik.values.natural_gas_domestic.approvalStatus, isEditor(user.role))}
                />
                {/* {formik.values.natural_gas_domestic.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      size="small"
                      color="teal"  type="button"
                      onClick={() => {
                        openUpdateSite(
                          t("natural_gas_domestic"),
                          "natural_gas_domestic"
                        );
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"natural_gas_domestic"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}       
           {findActiveFieldByName("natural_gas_total_cost") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.natural_gas_total_cost.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("natural_gas_total_cost")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  name="natural_gas_total_cost.value"
                  value={formik.values.natural_gas_total_cost.value}
                  error={formik.errors.natural_gas_total_cost?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.natural_gas_total_cost?.unit &&
                    formik.touched.natural_gas_total_cost?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.natural_gas_total_cost.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineEnergyUnits("natural_gas_total_cost").map(
                      (ds) => {
                        return {
                          key: ds.key,
                          text: ds.name,
                          value: ds.value,
                        };
                      }
                    )}
                    selection
                      disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "natural_gas_total_cost.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "natural_gas_total_cost.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "natural_gas_total_cost.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.natural_gas_total_cost.unit}
                    error={
                      !!formik.errors.natural_gas_total_cost?.unit &&
                      !!formik.touched.natural_gas_total_cost?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.natural_gas_total_cost?.unit &&
                        formik.touched.natural_gas_total_cost?.unit
                          ? "red"
                          : undefined,
                    }}
                       name="natural_gas_total_cost.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>

              <Table.Cell>
                <Form.Dropdown
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: 'green', empty: true, circular: true }
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: 'yellow', empty: true, circular: true }
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: 'red', empty: true, circular: true }
                    },
                  ]}
                  selection
                  disabled={isEditor(user.role)}
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      `natural_gas_total_cost.approvalStatus`,
                      data.value
                    )
                  }
                  value={formik.values.natural_gas_total_cost.approvalStatus}
                  error={formik.errors.natural_gas_total_cost?.approvalStatus}
                  style={getApprovalStatusStyle(formik.values.natural_gas_total_cost.approvalStatus, isEditor(user.role))}
                />
                {/* {formik.values.natural_gas_total_cost.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      size="small"
                      color="teal"  type="button"
                      onClick={() => {
                        openUpdateSite(
                          t("natural_gas_total_cost"),
                          "natural_gas_total_cost"
                        );
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"natural_gas_total_cost"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}

                  {findActiveFieldByName("glp_combined") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.glp_combined.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("glp_combined")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  name="glp_combined.value"
                  value={formik.values.glp_combined.value}
                  error={formik.errors.glp_combined?.value}
                  disabled={
                    (formik.values.glp_production_operations?.value > 0) ||
                    (formik.values.glp_domestic?.value > 0) ||
                    crossMonthRestrictions.glp_combined
                  }
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.glp_combined?.unit &&
                    formik.touched.glp_combined?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.glp_combined.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineEnergyUnits("glp_combined").map(
                      (ds) => {
                        return {
                          key: ds.key,
                          text: ds.name,
                          value: ds.value,
                        };
                      }
                    )}
                    selection
                      disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "glp_combined.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "glp_combined.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "glp_combined.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.glp_combined.unit}
                    error={
                      !!formik.errors.glp_combined?.unit &&
                      !!formik.touched.glp_combined?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.glp_combined?.unit &&
                        formik.touched.glp_combined?.unit
                          ? "red"
                          : undefined,
                    }}
                            name="glp_combined.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>

              <Table.Cell>
                <Form.Dropdown
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: 'green', empty: true, circular: true }
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: 'yellow', empty: true, circular: true }
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: 'red', empty: true, circular: true }
                    },
                  ]}
                  selection
                  disabled={isEditor(user.role)}
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      `glp_combined.approvalStatus`,
                      data.value
                    )
                  }
                  value={formik.values.glp_combined.approvalStatus}
                  error={formik.errors.glp_combined?.approvalStatus}
                  style={getApprovalStatusStyle(formik.values.glp_combined.approvalStatus, isEditor(user.role))}
                />
                {/* {formik.values.glp_combined.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      size="small"
                      color="teal"  type="button"
                      onClick={() => {
                        openUpdateSite(
                          t("glp_combined"),
                          "glp_combined"
                        );
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"glp_combined"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
                  {findActiveFieldByName("glp_cogeneration") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.glp_cogeneration.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("glp_cogeneration")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  name="glp_cogeneration.value"
                  value={formik.values.glp_cogeneration.value}
                  error={formik.errors.glp_cogeneration?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.glp_cogeneration?.unit &&
                    formik.touched.glp_cogeneration?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.glp_cogeneration.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineEnergyUnits("glp_cogeneration").map(
                      (ds) => {
                        return {
                          key: ds.key,
                          text: ds.name,
                          value: ds.value,
                        };
                      }
                    )}
                    selection
                      disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "glp_cogeneration.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "glp_cogeneration.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "glp_cogeneration.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.glp_cogeneration.unit}
                    error={
                      !!formik.errors.glp_cogeneration?.unit &&
                      !!formik.touched.glp_cogeneration?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.glp_cogeneration?.unit &&
                        formik.touched.glp_cogeneration?.unit
                          ? "red"
                          : undefined,
                    }}
                     name="glp_cogeneration.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>

              <Table.Cell>
                <Form.Dropdown
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: 'green', empty: true, circular: true }
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: 'yellow', empty: true, circular: true }
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: 'red', empty: true, circular: true }
                    },
                  ]}
                  selection
                  disabled={isEditor(user.role)}
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      `glp_cogeneration.approvalStatus`,
                      data.value
                    )
                  }
                  value={formik.values.glp_cogeneration.approvalStatus}
                  error={formik.errors.glp_cogeneration?.approvalStatus}
                  style={getApprovalStatusStyle(formik.values.glp_cogeneration.approvalStatus, isEditor(user.role))}
                />
                {/* {formik.values.glp_cogeneration.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      size="small"
                      color="teal"  type="button"
                      onClick={() => {
                        openUpdateSite(
                          t("glp_cogeneration"),
                          "glp_cogeneration"
                        );
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"glp_cogeneration"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}        {findActiveFieldByName("glp_production_operations") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.glp_production_operations.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("glp_production_operations")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  name="glp_production_operations.value"
                  value={formik.values.glp_production_operations.value}
                  error={formik.errors.glp_production_operations?.value}
                  disabled={
                    formik.values.glp_combined?.value > 0 ||
                    crossMonthRestrictions.glp_production_operations
                  }
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.glp_production_operations?.unit &&
                    formik.touched.glp_production_operations?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.glp_production_operations.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineEnergyUnits("glp_production_operations").map(
                      (ds) => {
                        return {
                          key: ds.key,
                          text: ds.name,
                          value: ds.value,
                        };
                      }
                    )}
                    selection
                      disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "glp_production_operations.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "glp_production_operations.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "glp_production_operations.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.glp_production_operations.unit}
                    error={
                      !!formik.errors.glp_production_operations?.unit &&
                      !!formik.touched.glp_production_operations?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.glp_production_operations?.unit &&
                        formik.touched.glp_production_operations?.unit
                          ? "red"
                          : undefined,
                    }}
                       name="glp_production_operations.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>

              <Table.Cell>
                <Form.Dropdown
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: 'green', empty: true, circular: true }
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: 'yellow', empty: true, circular: true }
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: 'red', empty: true, circular: true }
                    },
                  ]}
                  selection
                  disabled={isEditor(user.role)}
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      `glp_production_operations.approvalStatus`,
                      data.value
                    )
                  }
                  value={formik.values.glp_production_operations.approvalStatus}
                  error={formik.errors.glp_production_operations?.approvalStatus}
                  style={getApprovalStatusStyle(formik.values.glp_production_operations.approvalStatus, isEditor(user.role))}
                />
                {/* {formik.values.glp_production_operations.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      size="small"
                      color="teal"  type="button"
                      onClick={() => {
                        openUpdateSite(
                          t("glp_production_operations"),
                          "glp_production_operations"
                        );
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"glp_production_operations"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}        {findActiveFieldByName("glp_domestic") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.glp_domestic.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("glp_domestic")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  name="glp_domestic.value"
                  value={formik.values.glp_domestic.value}
                  error={formik.errors.glp_domestic?.value}
                  disabled={
                    formik.values.glp_combined?.value > 0 ||
                    crossMonthRestrictions.glp_domestic
                  }
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.glp_domestic?.unit &&
                    formik.touched.glp_domestic?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.glp_domestic.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineEnergyUnits("glp_domestic").map(
                      (ds) => {
                        return {
                          key: ds.key,
                          text: ds.name,
                          value: ds.value,
                        };
                      }
                    )}
                    selection
                      disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "glp_domestic.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "glp_domestic.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "glp_domestic.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.glp_domestic.unit}
                    error={
                      !!formik.errors.glp_domestic?.unit &&
                      !!formik.touched.glp_domestic?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.glp_domestic?.unit &&
                        formik.touched.glp_domestic?.unit
                          ? "red"
                          : undefined,
                    }}
                       name="glp_domestic.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>

              <Table.Cell>
                <Form.Dropdown
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: 'green', empty: true, circular: true }
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: 'yellow', empty: true, circular: true }
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: 'red', empty: true, circular: true }
                    },
                  ]}
                  selection
                  disabled={isEditor(user.role)}
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      `glp_domestic.approvalStatus`,
                      data.value
                    )
                  }
                  value={formik.values.glp_domestic.approvalStatus}
                  error={formik.errors.glp_domestic?.approvalStatus}
                  style={getApprovalStatusStyle(formik.values.glp_domestic.approvalStatus, isEditor(user.role))}
                />
                {/* {formik.values.glp_domestic.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      size="small"
                      color="teal"  type="button"
                      onClick={() => {
                        openUpdateSite(
                          t("glp_domestic"),
                          "glp_domestic"
                        );
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"glp_domestic"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}        {findActiveFieldByName("glp_total_cost") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.glp_total_cost.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("glp_total_cost")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  name="glp_total_cost.value"
                  value={formik.values.glp_total_cost.value}
                  error={formik.errors.glp_total_cost?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.glp_total_cost?.unit &&
                    formik.touched.glp_total_cost?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.glp_total_cost.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineEnergyUnits("glp_total_cost").map(
                      (ds) => {
                        return {
                          key: ds.key,
                          text: ds.name,
                          value: ds.value,
                        };
                      }
                    )}
                    selection
                      disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "glp_total_cost.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "glp_total_cost.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "glp_total_cost.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.glp_total_cost.unit}
                    error={
                      !!formik.errors.glp_total_cost?.unit &&
                      !!formik.touched.glp_total_cost?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.glp_total_cost?.unit &&
                        formik.touched.glp_total_cost?.unit
                          ? "red"
                          : undefined,
                    }}
                    name="glp_total_cost.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>

              <Table.Cell>
                <Form.Dropdown
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: 'green', empty: true, circular: true }
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: 'yellow', empty: true, circular: true }
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: 'red', empty: true, circular: true }
                    },
                  ]}
                  selection
                  disabled={isEditor(user.role)}
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      `glp_total_cost.approvalStatus`,
                      data.value
                    )
                  }
                  value={formik.values.glp_total_cost.approvalStatus}
                  error={formik.errors.glp_total_cost?.approvalStatus}
                  style={getApprovalStatusStyle(formik.values.glp_total_cost.approvalStatus, isEditor(user.role))}
                />
                {/* {formik.values.glp_total_cost.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      size="small"
                      color="teal"  type="button"
                      onClick={() => {
                        openUpdateSite(
                          t("glp_total_cost"),
                          "glp_total_cost"
                        );
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"glp_total_cost"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}        {findActiveFieldByName("heavy_fuel_oil_total") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.heavy_fuel_oil_total.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("heavy_fuel_oil_total")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  name="heavy_fuel_oil_total.value"
                  value={formik.values.heavy_fuel_oil_total.value}
                  error={formik.errors.heavy_fuel_oil_total?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.heavy_fuel_oil_total?.unit &&
                    formik.touched.heavy_fuel_oil_total?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.heavy_fuel_oil_total.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineEnergyUnits("heavy_fuel_oil_total").map(
                      (ds) => {
                        return {
                          key: ds.key,
                          text: ds.name,
                          value: ds.value,
                        };
                      }
                    )}
                    selection
                    disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "heavy_fuel_oil_total.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "heavy_fuel_oil_total.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "heavy_fuel_oil_total.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.heavy_fuel_oil_total.unit}
                    error={
                      !!formik.errors.heavy_fuel_oil_total?.unit &&
                      !!formik.touched.heavy_fuel_oil_total?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.heavy_fuel_oil_total?.unit &&
                        formik.touched.heavy_fuel_oil_total?.unit
                          ? "red"
                          : undefined,
                    }}
                      name="heavy_fuel_oil_total.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>

              <Table.Cell>
                <Form.Dropdown
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: 'green', empty: true, circular: true }
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: 'yellow', empty: true, circular: true }
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: 'red', empty: true, circular: true }
                    },
                  ]}
                  selection
                  disabled={isEditor(user.role)}
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      `heavy_fuel_oil_total.approvalStatus`,
                      data.value
                    )
                  }
                  value={formik.values.heavy_fuel_oil_total.approvalStatus}
                  error={formik.errors.heavy_fuel_oil_total?.approvalStatus}
                  style={getApprovalStatusStyle(formik.values.heavy_fuel_oil_total.approvalStatus, isEditor(user.role))}
                />
                {/* {formik.values.heavy_fuel_oil_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      size="small"
                      color="teal"  type="button"
                      onClick={() => {
                        openUpdateSite(
                          t("heavy_fuel_oil_total"),
                          "heavy_fuel_oil_total"
                        );
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"heavy_fuel_oil_total"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}        {findActiveFieldByName("heavy_fuel_oil_total_cost") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.heavy_fuel_oil_total_cost.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("heavy_fuel_oil_total_cost")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  name="heavy_fuel_oil_total_cost.value"
                  value={formik.values.heavy_fuel_oil_total_cost.value}
                  error={formik.errors.heavy_fuel_oil_total_cost?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.heavy_fuel_oil_total_cost?.unit &&
                    formik.touched.heavy_fuel_oil_total_cost?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.heavy_fuel_oil_total_cost.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineEnergyUnits("heavy_fuel_oil_total_cost").map(
                      (ds) => {
                        return {
                          key: ds.key,
                          text: ds.name,
                          value: ds.value,
                        };
                      }
                    )}
                    selection
                    disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "heavy_fuel_oil_total_cost.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "heavy_fuel_oil_total_cost.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "heavy_fuel_oil_total_cost.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.heavy_fuel_oil_total_cost.unit}
                    error={
                      !!formik.errors.heavy_fuel_oil_total_cost?.unit &&
                      !!formik.touched.heavy_fuel_oil_total_cost?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.heavy_fuel_oil_total_cost?.unit &&
                        formik.touched.heavy_fuel_oil_total_cost?.unit
                          ? "red"
                          : undefined,
                    }}
                     name="heavy_fuel_oil_total_cost.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>

              <Table.Cell>
                <Form.Dropdown
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: 'green', empty: true, circular: true }
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: 'yellow', empty: true, circular: true }
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: 'red', empty: true, circular: true }
                    },
                  ]}
                  selection
                  disabled={isEditor(user.role)}
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      `heavy_fuel_oil_total_cost.approvalStatus`,
                      data.value
                    )
                  }
                  value={formik.values.heavy_fuel_oil_total_cost.approvalStatus}
                  error={formik.errors.heavy_fuel_oil_total_cost?.approvalStatus}
                  style={getApprovalStatusStyle(formik.values.heavy_fuel_oil_total_cost.approvalStatus, isEditor(user.role))}
                />
                {/* {formik.values.heavy_fuel_oil_total_cost.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      size="small"
                      color="teal"  type="button"
                      onClick={() => {
                        openUpdateSite(
                          t("heavy_fuel_oil_total_cost"),
                          "heavy_fuel_oil_total_cost"
                        );
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"heavy_fuel_oil_total_cost"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}        {findActiveFieldByName("light_fuel_oil_total") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.light_fuel_oil_total.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("light_fuel_oil_total")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  name="light_fuel_oil_total.value"
                  value={formik.values.light_fuel_oil_total.value}
                  error={formik.errors.light_fuel_oil_total?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.light_fuel_oil_total?.unit &&
                    formik.touched.light_fuel_oil_total?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.light_fuel_oil_total.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineEnergyUnits("light_fuel_oil_total").map(
                      (ds) => {
                        return {
                          key: ds.key,
                          text: ds.name,
                          value: ds.value,
                        };
                      }
                    )}
                    selection
                    disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "light_fuel_oil_total.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "light_fuel_oil_total.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "light_fuel_oil_total.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.light_fuel_oil_total.unit}
                    error={
                      !!formik.errors.light_fuel_oil_total?.unit &&
                      !!formik.touched.light_fuel_oil_total?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.light_fuel_oil_total?.unit &&
                        formik.touched.light_fuel_oil_total?.unit
                          ? "red"
                          : undefined,
                    }}
                              name="light_fuel_oil_total.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>

              <Table.Cell>
                <Form.Dropdown
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: 'green', empty: true, circular: true }
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: 'yellow', empty: true, circular: true }
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: 'red', empty: true, circular: true }
                    },
                  ]}
                  selection
                  disabled={isEditor(user.role)}
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      `light_fuel_oil_total.approvalStatus`,
                      data.value
                    )
                  }
                  value={formik.values.light_fuel_oil_total.approvalStatus}
                  error={formik.errors.light_fuel_oil_total?.approvalStatus}
                  style={getApprovalStatusStyle(formik.values.light_fuel_oil_total.approvalStatus, isEditor(user.role))}
                />
                {/* {formik.values.light_fuel_oil_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      size="small"
                      color="teal"  type="button"
                      onClick={() => {
                        openUpdateSite(
                          t("light_fuel_oil_total"),
                          "light_fuel_oil_total"
                        );
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"light_fuel_oil_total"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}        {findActiveFieldByName("light_fuel_oil_total_cost") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.light_fuel_oil_total_cost.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("light_fuel_oil_total_cost")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  name="light_fuel_oil_total_cost.value"
                  value={formik.values.light_fuel_oil_total_cost.value}
                  error={formik.errors.light_fuel_oil_total_cost?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.light_fuel_oil_total_cost?.unit &&
                    formik.touched.light_fuel_oil_total_cost?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.light_fuel_oil_total_cost.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineEnergyUnits("light_fuel_oil_total_cost").map(
                      (ds) => {
                        return {
                          key: ds.key,
                          text: ds.name,
                          value: ds.value,
                        };
                      }
                    )}
                    selection
                    disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "light_fuel_oil_total_cost.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "light_fuel_oil_total_cost.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "light_fuel_oil_total_cost.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.light_fuel_oil_total_cost.unit}
                    error={
                      !!formik.errors.light_fuel_oil_total_cost?.unit &&
                      !!formik.touched.light_fuel_oil_total_cost?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.light_fuel_oil_total_cost?.unit &&
                        formik.touched.light_fuel_oil_total_cost?.unit
                          ? "red"
                          : undefined,
                    }}
                     name="light_fuel_oil_total_cost.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>

              <Table.Cell>
                <Form.Dropdown
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: 'green', empty: true, circular: true }
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: 'yellow', empty: true, circular: true }
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: 'red', empty: true, circular: true }
                    },
                  ]}
                  selection
                  disabled={isEditor(user.role)}
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      `light_fuel_oil_total_cost.approvalStatus`,
                      data.value
                    )
                  }
                  value={formik.values.light_fuel_oil_total_cost.approvalStatus}
                  error={formik.errors.light_fuel_oil_total_cost?.approvalStatus}
                  style={getApprovalStatusStyle(formik.values.light_fuel_oil_total_cost.approvalStatus, isEditor(user.role))}
                />
                {/* {formik.values.light_fuel_oil_total_cost.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      size="small"
                      color="teal"  type="button"
                      onClick={() => {
                        openUpdateSite(
                          t("light_fuel_oil_total_cost"),
                          "light_fuel_oil_total_cost"
                        );
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"light_fuel_oil_total_cost"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}        {findActiveFieldByName("coal_total") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.coal_total.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("coal_total")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  name="coal_total.value"
                  value={formik.values.coal_total.value}
                  error={formik.errors.coal_total?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.coal_total?.unit &&
                    formik.touched.coal_total?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.coal_total.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineEnergyUnits("coal_total").map(
                      (ds) => {
                        return {
                          key: ds.key,
                          text: ds.name,
                          value: ds.value,
                        };
                      }
                    )}
                    selection
                    disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "coal_total.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "coal_total.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "coal_total.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.coal_total.unit}
                    error={
                      !!formik.errors.coal_total?.unit &&
                      !!formik.touched.coal_total?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.coal_total?.unit &&
                        formik.touched.coal_total?.unit
                          ? "red"
                          : undefined,
                    }}
                        name="coal_total.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>

              <Table.Cell>
                <Form.Dropdown
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: 'green', empty: true, circular: true }
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: 'yellow', empty: true, circular: true }
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: 'red', empty: true, circular: true }
                    },
                  ]}
                  selection
                  disabled={isEditor(user.role)}
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      `coal_total.approvalStatus`,
                      data.value
                    )
                  }
                  value={formik.values.coal_total.approvalStatus}
                  error={formik.errors.coal_total?.approvalStatus}
                  style={getApprovalStatusStyle(formik.values.coal_total.approvalStatus, isEditor(user.role))}
                />
                {/* {formik.values.coal_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      size="small"
                      color="teal"  type="button"
                      onClick={() => {
                        openUpdateSite(
                          t("coal_total"),
                          "coal_total"
                        );
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"coal_total"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}        {findActiveFieldByName("coal_total_cost") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.coal_total_cost.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("coal_total_cost")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  name="coal_total_cost.value"
                  value={formik.values.coal_total_cost.value}
                  error={formik.errors.coal_total_cost?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.coal_total_cost?.unit &&
                    formik.touched.coal_total_cost?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.coal_total_cost.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineEnergyUnits("coal_total_cost").map(
                      (ds) => {
                        return {
                          key: ds.key,
                          text: ds.name,
                          value: ds.value,
                        };
                      }
                    )}
                    selection
                    disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "coal_total_cost.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "coal_total_cost.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "coal_total_cost.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.coal_total_cost.unit}
                    error={
                      !!formik.errors.coal_total_cost?.unit &&
                      !!formik.touched.coal_total_cost?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.coal_total_cost?.unit &&
                        formik.touched.coal_total_cost?.unit
                          ? "red"
                          : undefined,
                    }}
                     name="coal_total_cost.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>

              <Table.Cell>
                <Form.Dropdown
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: 'green', empty: true, circular: true }
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: 'yellow', empty: true, circular: true }
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: 'red', empty: true, circular: true }
                    },
                  ]}
                  selection
                  disabled={isEditor(user.role)}
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      `coal_total_cost.approvalStatus`,
                      data.value
                    )
                  }
                  value={formik.values.coal_total_cost.approvalStatus}
                  error={formik.errors.coal_total_cost?.approvalStatus}
                  style={getApprovalStatusStyle(formik.values.coal_total_cost.approvalStatus, isEditor(user.role))}
                />
                {/* {formik.values.coal_total_cost.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      size="small"
                      color="teal"  type="button"
                      onClick={() => {
                        openUpdateSite(
                          t("coal_total_cost"),
                          "coal_total_cost"
                        );
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"coal_total_cost"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}        {findActiveFieldByName("diesel_combined") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.diesel_combined.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("diesel_combined")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  name="diesel_combined.value"
                  value={formik.values.diesel_combined.value}
                  error={formik.errors.diesel_combined?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.diesel_combined?.unit &&
                    formik.touched.diesel_combined?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.diesel_combined.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineEnergyUnits("diesel_combined").map(
                      (ds) => {
                        return {
                          key: ds.key,
                          text: ds.name,
                          value: ds.value,
                        };
                      }
                    )}
                    selection
                      disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "diesel_combined.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "diesel_combined.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "diesel_combined.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.diesel_combined.unit}
                    error={
                      !!formik.errors.diesel_combined?.unit &&
                      !!formik.touched.diesel_combined?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.diesel_combined?.unit &&
                        formik.touched.diesel_combined?.unit
                          ? "red"
                          : undefined,
                    }}
                         name="diesel_combined.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>

              <Table.Cell>
                <Form.Dropdown
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: 'green', empty: true, circular: true }
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: 'yellow', empty: true, circular: true }
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: 'red', empty: true, circular: true }
                    },
                  ]}
                  selection
                  disabled={isEditor(user.role)}
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      `diesel_combined.approvalStatus`,
                      data.value
                    )
                  }
                  value={formik.values.diesel_combined.approvalStatus}
                  error={formik.errors.diesel_combined?.approvalStatus}
                  style={getApprovalStatusStyle(formik.values.diesel_combined.approvalStatus, isEditor(user.role))}
                />
                {/* {formik.values.diesel_combined.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      size="small"
                      color="teal"  type="button"
                      onClick={() => {
                        openUpdateSite(
                          t("diesel_combined"),
                          "diesel_combined"
                        );
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"diesel_combined"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}        {findActiveFieldByName("diesel_cogeneration") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.diesel_cogeneration.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("diesel_cogeneration")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  name="diesel_cogeneration.value"
                  value={formik.values.diesel_cogeneration.value}
                  error={formik.errors.diesel_cogeneration?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.diesel_cogeneration?.unit &&
                    formik.touched.diesel_cogeneration?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.diesel_cogeneration.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineEnergyUnits("diesel_cogeneration").map(
                      (ds) => {
                        return {
                          key: ds.key,
                          text: ds.name,
                          value: ds.value,
                        };
                      }
                    )}
                    selection
                      disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "diesel_cogeneration.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "diesel_cogeneration.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "diesel_cogeneration.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.diesel_cogeneration.unit}
                    error={
                      !!formik.errors.diesel_cogeneration?.unit &&
                      !!formik.touched.diesel_cogeneration?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.diesel_cogeneration?.unit &&
                        formik.touched.diesel_cogeneration?.unit
                          ? "red"
                          : undefined,
                    }}
                    name="diesel_cogeneration.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>

              <Table.Cell>
                <Form.Dropdown
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: 'green', empty: true, circular: true }
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: 'yellow', empty: true, circular: true }
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: 'red', empty: true, circular: true }
                    },
                  ]}
                  selection
                  disabled={isEditor(user.role)}
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      `diesel_cogeneration.approvalStatus`,
                      data.value
                    )
                  }
                  value={formik.values.diesel_cogeneration.approvalStatus}
                  error={formik.errors.diesel_cogeneration?.approvalStatus}
                  style={getApprovalStatusStyle(formik.values.diesel_cogeneration.approvalStatus, isEditor(user.role))}
                />
                {/* {formik.values.diesel_cogeneration.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      size="small"
                      color="teal"  type="button"
                      onClick={() => {
                        openUpdateSite(
                          t("diesel_cogeneration"),
                          "diesel_cogeneration"
                        );
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"diesel_cogeneration"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}        {findActiveFieldByName("diesel_production_operations") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.diesel_production_operations.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("diesel_production_operations")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  name="diesel_production_operations.value"
                  value={formik.values.diesel_production_operations.value}
                  error={formik.errors.diesel_production_operations?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.diesel_production_operations?.unit &&
                    formik.touched.diesel_production_operations?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.diesel_production_operations.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineEnergyUnits("diesel_production_operations").map(
                      (ds) => {
                        return {
                          key: ds.key,
                          text: ds.name,
                          value: ds.value,
                        };
                      }
                    )}
                    selection
                      disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "diesel_production_operations.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "diesel_production_operations.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "diesel_production_operations.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.diesel_production_operations.unit}
                    error={
                      !!formik.errors.diesel_production_operations?.unit &&
                      !!formik.touched.diesel_production_operations?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.diesel_production_operations?.unit &&
                        formik.touched.diesel_production_operations?.unit
                          ? "red"
                          : undefined,
                    }}
                        name="diesel_production_operations.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>

              <Table.Cell>
                <Form.Dropdown
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: 'green', empty: true, circular: true }
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: 'yellow', empty: true, circular: true }
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: 'red', empty: true, circular: true }
                    },
                  ]}
                  selection
                  disabled={isEditor(user.role)}
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      `diesel_production_operations.approvalStatus`,
                      data.value
                    )
                  }
                  value={formik.values.diesel_production_operations.approvalStatus}
                  error={formik.errors.diesel_production_operations?.approvalStatus}
                  style={getApprovalStatusStyle(formik.values.diesel_production_operations.approvalStatus, isEditor(user.role))}
                />
                {/* {formik.values.diesel_production_operations.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      size="small"
                      color="teal"  type="button"
                      onClick={() => {
                        openUpdateSite(
                          t("diesel_production_operations"),
                          "diesel_production_operations"
                        );
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"diesel_production_operations"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}        {findActiveFieldByName("diesel_forklifts") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.diesel_forklifts.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("diesel_forklifts")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  name="diesel_forklifts.value"
                  value={formik.values.diesel_forklifts.value}
                  error={formik.errors.diesel_forklifts?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.diesel_forklifts?.unit &&
                    formik.touched.diesel_forklifts?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.diesel_forklifts.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineEnergyUnits("diesel_forklifts").map(
                      (ds) => {
                        return {
                          key: ds.key,
                          text: ds.name,
                          value: ds.value,
                        };
                      }
                    )}
                    selection
                      disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "diesel_forklifts.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "diesel_forklifts.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "diesel_forklifts.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.diesel_forklifts.unit}
                    error={
                      !!formik.errors.diesel_forklifts?.unit &&
                      !!formik.touched.diesel_forklifts?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.diesel_forklifts?.unit &&
                        formik.touched.diesel_forklifts?.unit
                          ? "red"
                          : undefined,
                    }}
                        name="diesel_forklifts.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>

              <Table.Cell>
                <Form.Dropdown
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: 'green', empty: true, circular: true }
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: 'yellow', empty: true, circular: true }
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: 'red', empty: true, circular: true }
                    },
                  ]}
                  selection
                  disabled={isEditor(user.role)}
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      `diesel_forklifts.approvalStatus`,
                      data.value
                    )
                  }
                  value={formik.values.diesel_forklifts.approvalStatus}
                  error={formik.errors.diesel_forklifts?.approvalStatus}
                  style={getApprovalStatusStyle(formik.values.diesel_forklifts.approvalStatus, isEditor(user.role))}
                />
                {/* {formik.values.diesel_forklifts.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      size="small"
                      color="teal"  type="button"
                      onClick={() => {
                        openUpdateSite(
                          t("diesel_forklifts"),
                          "diesel_forklifts"
                        );
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"diesel_forklifts"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}        {findActiveFieldByName("diesel_total_cost") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.diesel_total_cost.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("diesel_total_cost")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  name="diesel_total_cost.value"
                  value={formik.values.diesel_total_cost.value}
                  error={formik.errors.diesel_total_cost?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.diesel_total_cost?.unit &&
                    formik.touched.diesel_total_cost?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.diesel_total_cost.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineEnergyUnits("diesel_total_cost").map(
                      (ds) => {
                        return {
                          key: ds.key,
                          text: ds.name,
                          value: ds.value,
                        };
                      }
                    )}
                    selection
                      disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "diesel_total_cost.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "diesel_total_cost.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "diesel_total_cost.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.diesel_total_cost.unit}
                    error={
                      !!formik.errors.diesel_total_cost?.unit &&
                      !!formik.touched.diesel_total_cost?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.diesel_total_cost?.unit &&
                        formik.touched.diesel_total_cost?.unit
                          ? "red"
                          : undefined,
                    }}
                          name="diesel_total_cost.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>

              <Table.Cell>
                <Form.Dropdown
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: 'green', empty: true, circular: true }
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: 'yellow', empty: true, circular: true }
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: 'red', empty: true, circular: true }
                    },
                  ]}
                  selection
                  disabled={isEditor(user.role)}
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      `diesel_total_cost.approvalStatus`,
                      data.value
                    )
                  }
                  value={formik.values.diesel_total_cost.approvalStatus}
                  error={formik.errors.diesel_total_cost?.approvalStatus}
                  style={getApprovalStatusStyle(formik.values.diesel_total_cost.approvalStatus, isEditor(user.role))}
                />
                {/* {formik.values.diesel_total_cost.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      size="small"
                      color="teal"  type="button"
                      onClick={() => {
                        openUpdateSite(
                          t("diesel_total_cost"),
                          "diesel_total_cost"
                        );
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"diesel_total_cost"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}        {findActiveFieldByName("biodiesel_combined") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.biodiesel_combined.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("biodiesel_combined")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  name="biodiesel_combined.value"
                  value={formik.values.biodiesel_combined.value}
                  error={formik.errors.biodiesel_combined?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.biodiesel_combined?.unit &&
                    formik.touched.biodiesel_combined?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.biodiesel_combined.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineEnergyUnits("biodiesel_combined").map(
                      (ds) => {
                        return {
                          key: ds.key,
                          text: ds.name,
                          value: ds.value,
                        };
                      }
                    )}
                    selection
                      disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "biodiesel_combined.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "biodiesel_combined.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "biodiesel_combined.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.biodiesel_combined.unit}
                    error={
                      !!formik.errors.biodiesel_combined?.unit &&
                      !!formik.touched.biodiesel_combined?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.biodiesel_combined?.unit &&
                        formik.touched.biodiesel_combined?.unit
                          ? "red"
                          : undefined,
                    }}
                     name="biodiesel_combined.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>

              <Table.Cell>
                <Form.Dropdown
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: 'green', empty: true, circular: true }
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: 'yellow', empty: true, circular: true }
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: 'red', empty: true, circular: true }
                    },
                  ]}
                  selection
                  disabled={isEditor(user.role)}
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      `biodiesel_combined.approvalStatus`,
                      data.value
                    )
                  }
                  value={formik.values.biodiesel_combined.approvalStatus}
                  error={formik.errors.biodiesel_combined?.approvalStatus}
                  style={getApprovalStatusStyle(formik.values.biodiesel_combined.approvalStatus, isEditor(user.role))}
                />
                {/* {formik.values.biodiesel_combined.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      size="small"
                      color="teal"  type="button"
                      onClick={() => {
                        openUpdateSite(
                          t("biodiesel_combined"),
                          "biodiesel_combined"
                        );
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"biodiesel_combined"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}        {findActiveFieldByName("biodiesel_cogeneration") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.biodiesel_cogeneration.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("biodiesel_cogeneration")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  name="biodiesel_cogeneration.value"
                  value={formik.values.biodiesel_cogeneration.value}
                  error={formik.errors.biodiesel_cogeneration?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.biodiesel_cogeneration?.unit &&
                    formik.touched.biodiesel_cogeneration?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.biodiesel_cogeneration.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineEnergyUnits("biodiesel_cogeneration").map(
                      (ds) => {
                        return {
                          key: ds.key,
                          text: ds.name,
                          value: ds.value,
                        };
                      }
                    )}
                    selection
                      disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "biodiesel_cogeneration.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "biodiesel_cogeneration.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "biodiesel_cogeneration.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.biodiesel_cogeneration.unit}
                    error={
                      !!formik.errors.biodiesel_cogeneration?.unit &&
                      !!formik.touched.biodiesel_cogeneration?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.biodiesel_cogeneration?.unit &&
                        formik.touched.biodiesel_cogeneration?.unit
                          ? "red"
                          : undefined,
                    }}
                        name="biodiesel_cogeneration.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>

              <Table.Cell>
                <Form.Dropdown
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: 'green', empty: true, circular: true }
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: 'yellow', empty: true, circular: true }
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: 'red', empty: true, circular: true }
                    },
                  ]}
                  selection
                  disabled={isEditor(user.role)}
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      `biodiesel_cogeneration.approvalStatus`,
                      data.value
                    )
                  }
                  value={formik.values.biodiesel_cogeneration.approvalStatus}
                  error={formik.errors.biodiesel_cogeneration?.approvalStatus}
                  style={getApprovalStatusStyle(formik.values.biodiesel_cogeneration.approvalStatus, isEditor(user.role))}
                />
                {/* {formik.values.biodiesel_cogeneration.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      size="small"
                      color="teal"  type="button"
                      onClick={() => {
                        openUpdateSite(
                          t("biodiesel_cogeneration"),
                          "biodiesel_cogeneration"
                        );
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"biodiesel_cogeneration"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}        {findActiveFieldByName("biodiesel_production_operations") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.biodiesel_production_operations.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("biodiesel_production_operations")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  name="biodiesel_production_operations.value"
                  value={formik.values.biodiesel_production_operations.value}
                  error={formik.errors.biodiesel_production_operations?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.biodiesel_production_operations?.unit &&
                    formik.touched.biodiesel_production_operations?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.biodiesel_production_operations.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineEnergyUnits("biodiesel_production_operations").map(
                      (ds) => {
                        return {
                          key: ds.key,
                          text: ds.name,
                          value: ds.value,
                        };
                      }
                    )}
                    selection
                      disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "biodiesel_production_operations.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "biodiesel_production_operations.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "biodiesel_production_operations.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.biodiesel_production_operations.unit}
                    error={
                      !!formik.errors.biodiesel_production_operations?.unit &&
                      !!formik.touched.biodiesel_production_operations?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.biodiesel_production_operations?.unit &&
                        formik.touched.biodiesel_production_operations?.unit
                          ? "red"
                          : undefined,
                    }}
                      name="biodiesel_production_operations.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>

              <Table.Cell>
                <Form.Dropdown
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: 'green', empty: true, circular: true }
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: 'yellow', empty: true, circular: true }
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: 'red', empty: true, circular: true }
                    },
                  ]}
                  selection
                  disabled={isEditor(user.role)}
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      `biodiesel_production_operations.approvalStatus`,
                      data.value
                    )
                  }
                  value={formik.values.biodiesel_production_operations.approvalStatus}
                  error={formik.errors.biodiesel_production_operations?.approvalStatus}
                  style={getApprovalStatusStyle(formik.values.biodiesel_production_operations.approvalStatus, isEditor(user.role))}
                />
                {/* {formik.values.biodiesel_production_operations.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      size="small"
                      color="teal"  type="button"
                      onClick={() => {
                        openUpdateSite(
                          t("biodiesel_production_operations"),
                          "biodiesel_production_operations"
                        );
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"biodiesel_production_operations"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}        {findActiveFieldByName("biodiesel_forklifts") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.biodiesel_forklifts.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("biodiesel_forklifts")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  name="biodiesel_forklifts.value"
                  value={formik.values.biodiesel_forklifts.value}
                  error={formik.errors.biodiesel_forklifts?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.biodiesel_forklifts?.unit &&
                    formik.touched.biodiesel_forklifts?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.biodiesel_forklifts.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineEnergyUnits("biodiesel_forklifts").map(
                      (ds) => {
                        return {
                          key: ds.key,
                          text: ds.name,
                          value: ds.value,
                        };
                      }
                    )}
                    selection
                      disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "biodiesel_forklifts.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "biodiesel_forklifts.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "biodiesel_forklifts.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.biodiesel_forklifts.unit}
                    error={
                      !!formik.errors.biodiesel_forklifts?.unit &&
                      !!formik.touched.biodiesel_forklifts?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.biodiesel_forklifts?.unit &&
                        formik.touched.biodiesel_forklifts?.unit
                          ? "red"
                          : undefined,
                    }}
                       name="biodiesel_forklifts.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>

              <Table.Cell>
                <Form.Dropdown
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: 'green', empty: true, circular: true }
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: 'yellow', empty: true, circular: true }
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: 'red', empty: true, circular: true }
                    },
                  ]}
                  selection
                  disabled={isEditor(user.role)}
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      `biodiesel_forklifts.approvalStatus`,
                      data.value
                    )
                  }
                  value={formik.values.biodiesel_forklifts.approvalStatus}
                  error={formik.errors.biodiesel_forklifts?.approvalStatus}
                  style={getApprovalStatusStyle(formik.values.biodiesel_forklifts.approvalStatus, isEditor(user.role))}
                />
                {/* {formik.values.biodiesel_forklifts.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      size="small"
                      color="teal"  type="button"
                      onClick={() => {
                        openUpdateSite(
                          t("biodiesel_forklifts"),
                          "biodiesel_forklifts"
                        );
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"biodiesel_forklifts"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}        {findActiveFieldByName("biodiesel_total_cost") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.biodiesel_total_cost.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("biodiesel_total_cost")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  name="biodiesel_total_cost.value"
                  value={formik.values.biodiesel_total_cost.value}
                  error={formik.errors.biodiesel_total_cost?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.biodiesel_total_cost?.unit &&
                    formik.touched.biodiesel_total_cost?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.biodiesel_total_cost.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineEnergyUnits("biodiesel_total_cost").map(
                      (ds) => {
                        return {
                          key: ds.key,
                          text: ds.name,
                          value: ds.value,
                        };
                      }
                    )}
                    selection
                      disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "biodiesel_total_cost.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "biodiesel_total_cost.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "biodiesel_total_cost.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.biodiesel_total_cost.unit}
                    error={
                      !!formik.errors.biodiesel_total_cost?.unit &&
                      !!formik.touched.biodiesel_total_cost?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.biodiesel_total_cost?.unit &&
                        formik.touched.biodiesel_total_cost?.unit
                          ? "red"
                          : undefined,
                    }}
                       name="biodiesel_total_cost.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>

              <Table.Cell>
                <Form.Dropdown
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: 'green', empty: true, circular: true }
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: 'yellow', empty: true, circular: true }
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: 'red', empty: true, circular: true }
                    },
                  ]}
                  selection
                  disabled={isEditor(user.role)}
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      `biodiesel_total_cost.approvalStatus`,
                      data.value
                    )
                  }
                  value={formik.values.biodiesel_total_cost.approvalStatus}
                  error={formik.errors.biodiesel_total_cost?.approvalStatus}
                  style={getApprovalStatusStyle(formik.values.biodiesel_total_cost.approvalStatus, isEditor(user.role))}
                />
                {/* {formik.values.biodiesel_total_cost.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      size="small"
                      color="teal"  type="button"
                      onClick={() => {
                        openUpdateSite(
                          t("biodiesel_total_cost"),
                          "biodiesel_total_cost"
                        );
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"biodiesel_total_cost"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}  
          <Table.Row className="energy-form-section-header">
            <Table.Cell colSpan={7}>{t("liquid_fuels")}</Table.Cell>
          </Table.Row>
          
                {findActiveFieldByName("gasoline_combined") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.gasoline_combined.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("gasoline_combined")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  name="gasoline_combined.value"
                  value={formik.values.gasoline_combined.value}
                  error={formik.errors.gasoline_combined?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.gasoline_combined?.unit &&
                    formik.touched.gasoline_combined?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.gasoline_combined.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineEnergyUnits("gasoline_combined").map(
                      (ds) => {
                        return {
                          key: ds.key,
                          text: ds.name,
                          value: ds.value,
                        };
                      }
                    )}
                    selection
                      disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "gasoline_combined.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "gasoline_combined.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "gasoline_combined.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.gasoline_combined.unit}
                    error={
                      !!formik.errors.gasoline_combined?.unit &&
                      !!formik.touched.gasoline_combined?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.gasoline_combined?.unit &&
                        formik.touched.gasoline_combined?.unit
                          ? "red"
                          : undefined,
                    }}
                    name="gasoline_combined.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>

              <Table.Cell>
                <Form.Dropdown
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: 'green', empty: true, circular: true }
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: 'yellow', empty: true, circular: true }
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: 'red', empty: true, circular: true }
                    },
                  ]}
                  selection
                  disabled={isEditor(user.role)}
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      `gasoline_combined.approvalStatus`,
                      data.value
                    )
                  }
                  value={formik.values.gasoline_combined.approvalStatus}
                  error={formik.errors.gasoline_combined?.approvalStatus}
                  style={getApprovalStatusStyle(formik.values.gasoline_combined.approvalStatus, isEditor(user.role))}
                />
                {/* {formik.values.gasoline_combined.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      size="small"
                      color="teal"  type="button"
                      onClick={() => {
                        openUpdateSite(
                          t("gasoline_combined"),
                          "gasoline_combined"
                        );
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"gasoline_combined"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}        {findActiveFieldByName("gasoline_cogeneration") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.gasoline_cogeneration.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("gasoline_cogeneration")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  name="gasoline_cogeneration.value"
                  value={formik.values.gasoline_cogeneration.value}
                  error={formik.errors.gasoline_cogeneration?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.gasoline_cogeneration?.unit &&
                    formik.touched.gasoline_cogeneration?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.gasoline_cogeneration.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineEnergyUnits("gasoline_cogeneration").map(
                      (ds) => {
                        return {
                          key: ds.key,
                          text: ds.name,
                          value: ds.value,
                        };
                      }
                    )}
                    selection
                      disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "gasoline_cogeneration.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "gasoline_cogeneration.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "gasoline_cogeneration.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.gasoline_cogeneration.unit}
                    error={
                      !!formik.errors.gasoline_cogeneration?.unit &&
                      !!formik.touched.gasoline_cogeneration?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.gasoline_cogeneration?.unit &&
                        formik.touched.gasoline_cogeneration?.unit
                          ? "red"
                          : undefined,
                    }}
                        name="gasoline_cogeneration.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>

              <Table.Cell>
                <Form.Dropdown
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: 'green', empty: true, circular: true }
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: 'yellow', empty: true, circular: true }
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: 'red', empty: true, circular: true }
                    },
                  ]}
                  selection
                  disabled={isEditor(user.role)}
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      `gasoline_cogeneration.approvalStatus`,
                      data.value
                    )
                  }
                  value={formik.values.gasoline_cogeneration.approvalStatus}
                  error={formik.errors.gasoline_cogeneration?.approvalStatus}
                  style={getApprovalStatusStyle(formik.values.gasoline_cogeneration.approvalStatus, isEditor(user.role))}
                />
                {/* {formik.values.gasoline_cogeneration.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      size="small"
                      color="teal"  type="button"
                      onClick={() => {
                        openUpdateSite(
                          t("gasoline_cogeneration"),
                          "gasoline_cogeneration"
                        );
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"gasoline_cogeneration"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}        {findActiveFieldByName("gasoline_production_operations") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.gasoline_production_operations.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("gasoline_production_operations")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  name="gasoline_production_operations.value"
                  value={formik.values.gasoline_production_operations.value}
                  error={formik.errors.gasoline_production_operations?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.gasoline_production_operations?.unit &&
                    formik.touched.gasoline_production_operations?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.gasoline_production_operations.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineEnergyUnits("gasoline_production_operations").map(
                      (ds) => {
                        return {
                          key: ds.key,
                          text: ds.name,
                          value: ds.value,
                        };
                      }
                    )}
                    selection
                      disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "gasoline_production_operations.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "gasoline_production_operations.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "gasoline_production_operations.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.gasoline_production_operations.unit}
                    error={
                      !!formik.errors.gasoline_production_operations?.unit &&
                      !!formik.touched.gasoline_production_operations?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.gasoline_production_operations?.unit &&
                        formik.touched.gasoline_production_operations?.unit
                          ? "red"
                          : undefined,
                    }}
                        name="gasoline_production_operations.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>

              <Table.Cell>
                <Form.Dropdown
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: 'green', empty: true, circular: true }
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: 'yellow', empty: true, circular: true }
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: 'red', empty: true, circular: true }
                    },
                  ]}
                  selection
                  disabled={isEditor(user.role)}
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      `gasoline_production_operations.approvalStatus`,
                      data.value
                    )
                  }
                  value={formik.values.gasoline_production_operations.approvalStatus}
                  error={formik.errors.gasoline_production_operations?.approvalStatus}
                  style={getApprovalStatusStyle(formik.values.gasoline_production_operations.approvalStatus, isEditor(user.role))}
                />
                {/* {formik.values.gasoline_production_operations.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      size="small"
                      color="teal"  type="button"
                      onClick={() => {
                        openUpdateSite(
                          t("gasoline_production_operations"),
                          "gasoline_production_operations"
                        );
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"gasoline_production_operations"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}        {findActiveFieldByName("gasoline_forklifts") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.gasoline_forklifts.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("gasoline_forklifts")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  name="gasoline_forklifts.value"
                  value={formik.values.gasoline_forklifts.value}
                  error={formik.errors.gasoline_forklifts?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.gasoline_forklifts?.unit &&
                    formik.touched.gasoline_forklifts?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.gasoline_forklifts.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineEnergyUnits("gasoline_forklifts").map(
                      (ds) => {
                        return {
                          key: ds.key,
                          text: ds.name,
                          value: ds.value,
                        };
                      }
                    )}
                    selection
                      disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "gasoline_forklifts.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "gasoline_forklifts.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "gasoline_forklifts.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.gasoline_forklifts.unit}
                    error={
                      !!formik.errors.gasoline_forklifts?.unit &&
                      !!formik.touched.gasoline_forklifts?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.gasoline_forklifts?.unit &&
                        formik.touched.gasoline_forklifts?.unit
                          ? "red"
                          : undefined,
                    }}
                         name="gasoline_forklifts.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>

              <Table.Cell>
                <Form.Dropdown
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: 'green', empty: true, circular: true }
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: 'yellow', empty: true, circular: true }
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: 'red', empty: true, circular: true }
                    },
                  ]}
                  selection
                  disabled={isEditor(user.role)}
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      `gasoline_forklifts.approvalStatus`,
                      data.value
                    )
                  }
                  value={formik.values.gasoline_forklifts.approvalStatus}
                  error={formik.errors.gasoline_forklifts?.approvalStatus}
                  style={getApprovalStatusStyle(formik.values.gasoline_forklifts.approvalStatus, isEditor(user.role))}
                />
                {/* {formik.values.gasoline_forklifts.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      size="small"
                      color="teal"  type="button"
                      onClick={() => {
                        openUpdateSite(
                          t("gasoline_forklifts"),
                          "gasoline_forklifts"
                        );
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"gasoline_forklifts"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}        {findActiveFieldByName("gasoline_total_cost") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.gasoline_total_cost.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("gasoline_total_cost")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  name="gasoline_total_cost.value"
                  value={formik.values.gasoline_total_cost.value}
                  error={formik.errors.gasoline_total_cost?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.gasoline_total_cost?.unit &&
                    formik.touched.gasoline_total_cost?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.gasoline_total_cost.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineEnergyUnits("gasoline_total_cost").map(
                      (ds) => {
                        return {
                          key: ds.key,
                          text: ds.name,
                          value: ds.value,
                        };
                      }
                    )}
                    selection
                      disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "gasoline_total_cost.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "gasoline_total_cost.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "gasoline_total_cost.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.gasoline_total_cost.unit}
                    error={
                      !!formik.errors.gasoline_total_cost?.unit &&
                      !!formik.touched.gasoline_total_cost?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.gasoline_total_cost?.unit &&
                        formik.touched.gasoline_total_cost?.unit
                          ? "red"
                          : undefined,
                    }}
                     name="gasoline_total_cost.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>

              <Table.Cell>
                <Form.Dropdown
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: 'green', empty: true, circular: true }
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: 'yellow', empty: true, circular: true }
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: 'red', empty: true, circular: true }
                    },
                  ]}
                  selection
                  disabled={isEditor(user.role)}
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      `gasoline_total_cost.approvalStatus`,
                      data.value
                    )
                  }
                  value={formik.values.gasoline_total_cost.approvalStatus}
                  error={formik.errors.gasoline_total_cost?.approvalStatus}
                  style={getApprovalStatusStyle(formik.values.gasoline_total_cost.approvalStatus, isEditor(user.role))}
                />
                {/* {formik.values.gasoline_total_cost.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      size="small"
                      color="teal"  type="button"
                      onClick={() => {
                        openUpdateSite(
                          t("gasoline_total_cost"),
                          "gasoline_total_cost"
                        );
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"gasoline_total_cost"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}        {findActiveFieldByName("biofuel_combined") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.biofuel_combined.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("biofuel_combined")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  name="biofuel_combined.value"
                  value={formik.values.biofuel_combined.value}
                  error={formik.errors.biofuel_combined?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.biofuel_combined?.unit &&
                    formik.touched.biofuel_combined?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.biofuel_combined.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineEnergyUnits("biofuel_combined").map(
                      (ds) => {
                        return {
                          key: ds.key,
                          text: ds.name,
                          value: ds.value,
                        };
                      }
                    )}
                    selection
                      disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "biofuel_combined.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "biofuel_combined.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "biofuel_combined.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.biofuel_combined.unit}
                    error={
                      !!formik.errors.biofuel_combined?.unit &&
                      !!formik.touched.biofuel_combined?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.biofuel_combined?.unit &&
                        formik.touched.biofuel_combined?.unit
                          ? "red"
                          : undefined,
                    }}
                    name="biofuel_combined.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>

              <Table.Cell>
                <Form.Dropdown
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: 'green', empty: true, circular: true }
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: 'yellow', empty: true, circular: true }
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: 'red', empty: true, circular: true }
                    },
                  ]}
                  selection
                  disabled={isEditor(user.role)}
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      `biofuel_combined.approvalStatus`,
                      data.value
                    )
                  }
                  value={formik.values.biofuel_combined.approvalStatus}
                  error={formik.errors.biofuel_combined?.approvalStatus}
                  style={getApprovalStatusStyle(formik.values.biofuel_combined.approvalStatus, isEditor(user.role))}
                />
                {/* {formik.values.biofuel_combined.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      size="small"
                      color="teal"  type="button"
                      onClick={() => {
                        openUpdateSite(
                          t("biofuel_combined"),
                          "biofuel_combined"
                        );
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"biofuel_combined"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}        {findActiveFieldByName("biofuel_cogeneration") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.biofuel_cogeneration.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("biofuel_cogeneration")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  name="biofuel_cogeneration.value"
                  value={formik.values.biofuel_cogeneration.value}
                  error={formik.errors.biofuel_cogeneration?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.biofuel_cogeneration?.unit &&
                    formik.touched.biofuel_cogeneration?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.biofuel_cogeneration.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineEnergyUnits("biofuel_cogeneration").map(
                      (ds) => {
                        return {
                          key: ds.key,
                          text: ds.name,
                          value: ds.value,
                        };
                      }
                    )}
                    selection
                      disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "biofuel_cogeneration.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "biofuel_cogeneration.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "biofuel_cogeneration.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.biofuel_cogeneration.unit}
                    error={
                      !!formik.errors.biofuel_cogeneration?.unit &&
                      !!formik.touched.biofuel_cogeneration?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.biofuel_cogeneration?.unit &&
                        formik.touched.biofuel_cogeneration?.unit
                          ? "red"
                          : undefined,
                    }}
                     name="biofuel_cogeneration.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>

              <Table.Cell>
                <Form.Dropdown
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: 'green', empty: true, circular: true }
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: 'yellow', empty: true, circular: true }
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: 'red', empty: true, circular: true }
                    },
                  ]}
                  selection
                  disabled={isEditor(user.role)}
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      `biofuel_cogeneration.approvalStatus`,
                      data.value
                    )
                  }
                  value={formik.values.biofuel_cogeneration.approvalStatus}
                  error={formik.errors.biofuel_cogeneration?.approvalStatus}
                  style={getApprovalStatusStyle(formik.values.biofuel_cogeneration.approvalStatus, isEditor(user.role))}
                />
                {/* {formik.values.biofuel_cogeneration.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      size="small"
                      color="teal"  type="button"
                      onClick={() => {
                        openUpdateSite(
                          t("biofuel_cogeneration"),
                          "biofuel_cogeneration"
                        );
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"biofuel_cogeneration"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}        {findActiveFieldByName("biofuel_production_operations") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.biofuel_production_operations.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("biofuel_production_operations")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  name="biofuel_production_operations.value"
                  value={formik.values.biofuel_production_operations.value}
                  error={formik.errors.biofuel_production_operations?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.biofuel_production_operations?.unit &&
                    formik.touched.biofuel_production_operations?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.biofuel_production_operations.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineEnergyUnits("biofuel_production_operations").map(
                      (ds) => {
                        return {
                          key: ds.key,
                          text: ds.name,
                          value: ds.value,
                        };
                      }
                    )}
                    selection
                      disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "biofuel_production_operations.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "biofuel_production_operations.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "biofuel_production_operations.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.biofuel_production_operations.unit}
                    error={
                      !!formik.errors.biofuel_production_operations?.unit &&
                      !!formik.touched.biofuel_production_operations?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.biofuel_production_operations?.unit &&
                        formik.touched.biofuel_production_operations?.unit
                          ? "red"
                          : undefined,
                    }}
                     name="biofuel_production_operations.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>

              <Table.Cell>
                <Form.Dropdown
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: 'green', empty: true, circular: true }
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: 'yellow', empty: true, circular: true }
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: 'red', empty: true, circular: true }
                    },
                  ]}
                  selection
                  disabled={isEditor(user.role)}
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      `biofuel_production_operations.approvalStatus`,
                      data.value
                    )
                  }
                  value={formik.values.biofuel_production_operations.approvalStatus}
                  error={formik.errors.biofuel_production_operations?.approvalStatus}
                  style={getApprovalStatusStyle(formik.values.biofuel_production_operations.approvalStatus, isEditor(user.role))}
                />
                {/* {formik.values.biofuel_production_operations.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      size="small"
                      color="teal"  type="button"
                      onClick={() => {
                        openUpdateSite(
                          t("biofuel_production_operations"),
                          "biofuel_production_operations"
                        );
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"biofuel_production_operations"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}        {findActiveFieldByName("biofuel_forklifts") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.biofuel_forklifts.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("biofuel_forklifts")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  name="biofuel_forklifts.value"
                  value={formik.values.biofuel_forklifts.value}
                  error={formik.errors.biofuel_forklifts?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.biofuel_forklifts?.unit &&
                    formik.touched.biofuel_forklifts?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.biofuel_forklifts.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineEnergyUnits("biofuel_forklifts").map(
                      (ds) => {
                        return {
                          key: ds.key,
                          text: ds.name,
                          value: ds.value,
                        };
                      }
                    )}
                    selection
                      disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "biofuel_forklifts.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "biofuel_forklifts.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "biofuel_forklifts.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.biofuel_forklifts.unit}
                    error={
                      !!formik.errors.biofuel_forklifts?.unit &&
                      !!formik.touched.biofuel_forklifts?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.biofuel_forklifts?.unit &&
                        formik.touched.biofuel_forklifts?.unit
                          ? "red"
                          : undefined,
                    }}
                      name="biofuel_forklifts.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>

              <Table.Cell>
                <Form.Dropdown
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: 'green', empty: true, circular: true }
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: 'yellow', empty: true, circular: true }
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: 'red', empty: true, circular: true }
                    },
                  ]}
                  selection
                  disabled={isEditor(user.role)}
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      `biofuel_forklifts.approvalStatus`,
                      data.value
                    )
                  }
                  value={formik.values.biofuel_forklifts.approvalStatus}
                  error={formik.errors.biofuel_forklifts?.approvalStatus}
                  style={getApprovalStatusStyle(formik.values.biofuel_forklifts.approvalStatus, isEditor(user.role))}
                />
                {/* {formik.values.biofuel_forklifts.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      size="small"
                      color="teal"  type="button"
                      onClick={() => {
                        openUpdateSite(
                          t("biofuel_forklifts"),
                          "biofuel_forklifts"
                        );
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"biofuel_forklifts"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}        {findActiveFieldByName("biofuel_total_cost") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.biofuel_total_cost.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("biofuel_total_cost")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  name="biofuel_total_cost.value"
                  value={formik.values.biofuel_total_cost.value}
                  error={formik.errors.biofuel_total_cost?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.biofuel_total_cost?.unit &&
                    formik.touched.biofuel_total_cost?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.biofuel_total_cost.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineEnergyUnits("biofuel_total_cost").map(
                      (ds) => {
                        return {
                          key: ds.key,
                          text: ds.name,
                          value: ds.value,
                        };
                      }
                    )}
                    selection
                      disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "biofuel_total_cost.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "biofuel_total_cost.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "biofuel_total_cost.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.biofuel_total_cost.unit}
                    error={
                      !!formik.errors.biofuel_total_cost?.unit &&
                      !!formik.touched.biofuel_total_cost?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.biofuel_total_cost?.unit &&
                        formik.touched.biofuel_total_cost?.unit
                          ? "red"
                          : undefined,
                    }}
                     name="biofuel_total_cost.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>

              <Table.Cell>
                <Form.Dropdown
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: 'green', empty: true, circular: true }
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: 'yellow', empty: true, circular: true }
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: 'red', empty: true, circular: true }
                    },
                  ]}
                  selection
                  disabled={isEditor(user.role)}
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      `biofuel_total_cost.approvalStatus`,
                      data.value
                    )
                  }
                  value={formik.values.biofuel_total_cost.approvalStatus}
                  error={formik.errors.biofuel_total_cost?.approvalStatus}
                  style={getApprovalStatusStyle(formik.values.biofuel_total_cost.approvalStatus, isEditor(user.role))}
                />
                {/* {formik.values.biofuel_total_cost.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      size="small"
                      color="teal"  type="button"
                      onClick={() => {
                        openUpdateSite(
                          t("biofuel_total_cost"),
                          "biofuel_total_cost"
                        );
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"biofuel_total_cost"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}        {findActiveFieldByName("biomass_total") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.biomass_total.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("biomass_total")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  name="biomass_total.value"
                  value={formik.values.biomass_total.value}
                  error={formik.errors.biomass_total?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.biomass_total?.unit &&
                    formik.touched.biomass_total?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.biomass_total.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineEnergyUnits("biomass_total").map(
                      (ds) => {
                        return {
                          key: ds.key,
                          text: ds.name,
                          value: ds.value,
                        };
                      }
                    )}
                    selection
                      disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "biomass_total.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "biomass_total.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "biomass_total.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.biomass_total.unit}
                    error={
                      !!formik.errors.biomass_total?.unit &&
                      !!formik.touched.biomass_total?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.biomass_total?.unit &&
                        formik.touched.biomass_total?.unit
                          ? "red"
                          : undefined,
                    }}
                     name="biomass_total.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>

              <Table.Cell>
                <Form.Dropdown
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: 'green', empty: true, circular: true }
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: 'yellow', empty: true, circular: true }
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: 'red', empty: true, circular: true }
                    },
                  ]}
                  selection
                  disabled={isEditor(user.role)}
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      `biomass_total.approvalStatus`,
                      data.value
                    )
                  }
                  value={formik.values.biomass_total.approvalStatus}
                  error={formik.errors.biomass_total?.approvalStatus}
                  style={getApprovalStatusStyle(formik.values.biomass_total.approvalStatus, isEditor(user.role))}
                />
                {/* {formik.values.biomass_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      size="small"
                      color="teal"  type="button"
                      onClick={() => {
                        openUpdateSite(
                          t("biomass_total"),
                          "biomass_total"
                        );
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"biomass_total"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}        {findActiveFieldByName("biomass_total_cost") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.biomass_total_cost.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("biomass_total_cost")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  name="biomass_total_cost.value"
                  value={formik.values.biomass_total_cost.value}
                  error={formik.errors.biomass_total_cost?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.biomass_total_cost?.unit &&
                    formik.touched.biomass_total_cost?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.biomass_total_cost.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineEnergyUnits("biomass_total_cost").map(
                      (ds) => {
                        return {
                          key: ds.key,
                          text: ds.name,
                          value: ds.value,
                        };
                      }
                    )}
                    selection
                      disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "biomass_total_cost.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "biomass_total_cost.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "biomass_total_cost.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.biomass_total_cost.unit}
                    error={
                      !!formik.errors.biomass_total_cost?.unit &&
                      !!formik.touched.biomass_total_cost?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.biomass_total_cost?.unit &&
                        formik.touched.biomass_total_cost?.unit
                          ? "red"
                          : undefined,
                    }}
                       name="biomass_total_cost.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>

              <Table.Cell>
                <Form.Dropdown
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: 'green', empty: true, circular: true }
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: 'yellow', empty: true, circular: true }
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: 'red', empty: true, circular: true }
                    },
                  ]}
                  selection
                  disabled={isEditor(user.role)}
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      `biomass_total_cost.approvalStatus`,
                      data.value
                    )
                  }
                  value={formik.values.biomass_total_cost.approvalStatus}
                  error={formik.errors.biomass_total_cost?.approvalStatus}
                  style={getApprovalStatusStyle(formik.values.biomass_total_cost.approvalStatus, isEditor(user.role))}
                />
                {/* {formik.values.biomass_total_cost.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      size="small"
                      color="teal"  type="button"
                      onClick={() => {
                        openUpdateSite(
                          t("biomass_total_cost"),
                          "biomass_total_cost"
                        );
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"biomass_total_cost"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}        {findActiveFieldByName("steam_total") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.steam_total.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("steam_total")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  name="steam_total.value"
                  value={formik.values.steam_total.value}
                  error={formik.errors.steam_total?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.steam_total?.unit &&
                    formik.touched.steam_total?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.steam_total.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineEnergyUnits("steam_total").map(
                      (ds) => {
                        return {
                          key: ds.key,
                          text: ds.name,
                          value: ds.value,
                        };
                      }
                    )}
                    selection
                      disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "steam_total.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "steam_total.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "steam_total.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.steam_total.unit}
                    error={
                      !!formik.errors.steam_total?.unit &&
                      !!formik.touched.steam_total?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.steam_total?.unit &&
                        formik.touched.steam_total?.unit
                          ? "red"
                          : undefined,
                    }}
                       name="steam_total.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>

              <Table.Cell>
                <Form.Dropdown
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: 'green', empty: true, circular: true }
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: 'yellow', empty: true, circular: true }
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: 'red', empty: true, circular: true }
                    },
                  ]}
                  selection
                  disabled={isEditor(user.role)}
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      `steam_total.approvalStatus`,
                      data.value
                    )
                  }
                  value={formik.values.steam_total.approvalStatus}
                  error={formik.errors.steam_total?.approvalStatus}
                  style={getApprovalStatusStyle(formik.values.steam_total.approvalStatus, isEditor(user.role))}
                />
                {/* {formik.values.steam_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      size="small"
                      color="teal"  type="button"
                      onClick={() => {
                        openUpdateSite(
                          t("steam_total"),
                          "steam_total"
                        );
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"steam_total"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}        {findActiveFieldByName("steam_total_cost") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.steam_total_cost.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("steam_total_cost")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  name="steam_total_cost.value"
                  value={formik.values.steam_total_cost.value}
                  error={formik.errors.steam_total_cost?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.steam_total_cost?.unit &&
                    formik.touched.steam_total_cost?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.steam_total_cost.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineEnergyUnits("steam_total_cost").map(
                      (ds) => {
                        return {
                          key: ds.key,
                          text: ds.name,
                          value: ds.value,
                        };
                      }
                    )}
                    selection
                      disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "steam_total_cost.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "steam_total_cost.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "steam_total_cost.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.steam_total_cost.unit}
                    error={
                      !!formik.errors.steam_total_cost?.unit &&
                      !!formik.touched.steam_total_cost?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.steam_total_cost?.unit &&
                        formik.touched.steam_total_cost?.unit
                          ? "red"
                          : undefined,
                    }}
                       name="steam_total_cost.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>

              <Table.Cell>
                <Form.Dropdown
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: 'green', empty: true, circular: true }
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: 'yellow', empty: true, circular: true }
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: 'red', empty: true, circular: true }
                    },
                  ]}
                  selection
                  disabled={isEditor(user.role)}
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      `steam_total_cost.approvalStatus`,
                      data.value
                    )
                  }
                  value={formik.values.steam_total_cost.approvalStatus}
                  error={formik.errors.steam_total_cost?.approvalStatus}
                  style={getApprovalStatusStyle(formik.values.steam_total_cost.approvalStatus, isEditor(user.role))}
                />
                {/* {formik.values.steam_total_cost.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      size="small"
                      color="teal"  type="button"
                      onClick={() => {
                        openUpdateSite(
                          t("steam_total_cost"),
                          "steam_total_cost"
                        );
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"steam_total_cost"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
     
        </Table.Body>
      </Table>

      <ToastContainer
        position="bottom-center"
        autoClose={1200}
        hideProgressBar
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />

 {/* {console.log("showModalInt:", showModalInt)} */}
 


<BasicModal
  show={showModalInt}
  onClose={() => setShowModalInt(false)}       // cerrar desde aquí
  title={titleModal}
  size="tiny"
  closeOnDimmerClick={false}             // evita cierre al hacer clic fuera
  closeOnEscape={false}                   // opcional
>
  
  <div onClick={(e) => e.stopPropagation()}>
    <Comments
      formik={formik}
      fieldName={fieldName}
      onClose={() => setShowModalInt(false)}  // cerrar solo con botón
      onReload={onReload}                  // si necesitas recargar datos
      energyForm={energyForm}
      user={user}
      t={t}
    />
  </div>
</BasicModal> 
      <div
        style={{ display: "flex", justifyContent: "flex-end", gap: "0.5rem", alignItems: "center" }}
      >
        <Button
          type="submit"
          primary
          size="large"
          loading={formik.isSubmitting}
          content={!energyForm ? t("save") : t("update")}
        />

        <Button
          type="button"
          color="red"
          secondary
          size="large"
          onClick={() => {
            onClose ? onClose() : goBack();
          }}
        >
          {t("cancel")}
        </Button>
      </div>

      {/* Modal de carga de factura */}
      <Modal
        open={showUploadModal}
        onClose={() => !invoiceLoading && setShowUploadModal(false)}
        size="small"
        closeOnDimmerClick={!invoiceLoading}
        className="invoice-reader-modal"
      >
        <Modal.Header>
          <Icon name="file alternate outline" /> {t("read_invoice") || "Leer factura"}
        </Modal.Header>
        <Modal.Content>
          <InvoiceDropzone
            onFiles={processInvoiceFiles}
            loading={invoiceLoading}
            t={t}
            inputRef={invoiceInputRef}
            onInputChange={handleInvoiceFileChange}
          />
        </Modal.Content>
        <Modal.Actions>
          <Button secondary onClick={() => setShowUploadModal(false)} disabled={invoiceLoading}>
            {t("cancel")}
          </Button>
        </Modal.Actions>
      </Modal>

      {/* Modal preview de datos extraídos de la factura */}
      <Modal
        open={showInvoiceModal}
        onClose={() => { setShowInvoiceModal(false); setBulkSaveResults(null); setApplyWarning(null); }}
        size="small"
        closeOnDimmerClick={false}
        className="invoice-preview-modal"
      >
        <Modal.Header>
          <Icon name="file alternate outline" /> {t("extracted_invoice_data")}
        </Modal.Header>
        <Modal.Content scrolling>
          {invoiceResults.length > 0 && (() => {
            // Ordenar por año y período (errores al final)
            const sorted = [...invoiceResults].sort((a, b) => {
              if (a.error && !b.error) return 1;
              if (!a.error && b.error) return -1;
              const yearDiff = (b.year || 0) - (a.year || 0);
              if (yearDiff !== 0) return yearDiff;
              return (b.period || 0) - (a.period || 0);
            });

            return (
              <div className="invoice-reader-preview">
                <Message info size="small" style={{ marginBottom: "0.75rem" }}>
                  <Icon name="info circle" />
                  {t("review_before_applying") || "Revisá los datos antes de aplicar. Hacé clic en Aplicar en la fila deseada."}
                </Message>
                {invoiceResults.some((r) => r.needsReview) && (
                  <Message warning size="small" style={{ marginBottom: "0.75rem" }}>
                    <Icon name="warning sign" />
                    {`Se detectaron ${invoiceResults.find((r) => r.needsReview)?.pagesDetected} páginas pero solo se pudo extraer 1 factura. Revisá los datos con cuidado antes de guardar — puede haber varios meses mezclados en una sola fila.`}
                  </Message>
                )}
                {invoicePeriodMismatch && (
                  <Message warning size="small" style={{ marginBottom: "0.75rem" }}>
                    <Icon name="warning sign" />
                    {"Las facturas detectadas son de períodos distintos — revisá que cada fila vaya al mes correcto antes de aplicar."}
                  </Message>
                )}
                {(() => {
                  // Agrupar por año-período (errores en grupo aparte al final)
                  const groups = [];
                  const groupMap = new Map();
                  sorted.forEach(r => {
                    const key = r.error ? "__errors__" : (r.year && r.period ? `${r.year}-${r.period}` : "__unknown__");
                    if (!groupMap.has(key)) {
                      groupMap.set(key, { key, year: r.year, period: r.period, isError: !!r.error, isUnknown: !r.year || !r.period, rows: [] });
                      groups.push(groupMap.get(key));
                    }
                    groupMap.get(key).rows.push(r);
                  });

                  const MONTH_NAMES = ["Ene","Feb","Mar","Abr","May","Jun","Jul","Ago","Sep","Oct","Nov","Dic"];

                  return (
                    <Table size="small" compact>
                      <Table.Header>
                        <Table.Row>
                          <Table.HeaderCell>{t("file") || "Archivo"}</Table.HeaderCell>
                          <Table.HeaderCell>{t("electric_consumption") || "Valor (kWh)"}</Table.HeaderCell>
                          <Table.HeaderCell>{t("cost") || "Costo"}</Table.HeaderCell>
                          <Table.HeaderCell style={{ width: "9em" }}></Table.HeaderCell>
                        </Table.Row>
                      </Table.Header>
                      <Table.Body>
                        {groups.map(group => (
                          <React.Fragment key={group.key}>
                            <Table.Row>
                              <Table.Cell
                                colSpan={4}
                                style={{
                                  background: group.isError ? "#fff0f0" : "#f0f4f9",
                                  padding: "5px 10px",
                                  borderTop: "2px solid #d0dce8",
                                }}
                              >
                                <Icon
                                  name={group.isError ? "exclamation triangle" : "calendar alternate outline"}
                                  style={{ color: group.isError ? "#c0392b" : "#648EBC" }}
                                />
                                <strong style={{ fontSize: "0.88em", color: group.isError ? "#c0392b" : "#2c5282" }}>
                                  {group.isError
                                    ? (t("errors") || "Errores")
                                    : group.isUnknown
                                      ? (t("period_not_detected") || "Período no detectado")
                                      : `${MONTH_NAMES[(group.period || 1) - 1]} ${group.year}`}
                                </strong>
                                <span style={{ marginLeft: "8px", fontSize: "0.78em", color: "#888" }}>
                                  ({group.rows.length} {group.rows.length === 1 ? (t("file") || "archivo") : (t("files") || "archivos")})
                                </span>
                              </Table.Cell>
                            </Table.Row>
                            {group.rows.map((r, i) => (
                              <Table.Row key={r._rowId || i} negative={!!r.error}>
                                <Table.Cell>
                                  <Icon name="paperclip" />
                                  <span style={{ fontSize: "0.85em" }}>{r.filename}</span>
                                  {r.format && <span style={{ marginLeft: "0.4rem", background: "#e8f4fd", color: "#1a6ba0", borderRadius: "4px", padding: "1px 6px", fontSize: "0.72rem", fontWeight: 600, textTransform: "uppercase" }}>{r.format}</span>}
                                  {r.energyType && r.energyType !== "electricity" && (
                                    <span style={{ marginLeft: "0.4rem", background: "#f3e8d8", color: "#8a5a1e", borderRadius: "4px", padding: "1px 6px", fontSize: "0.72rem", fontWeight: 600 }}>
                                      {t(r.energyType) || r.energyType}
                                    </span>
                                  )}
                                </Table.Cell>
                                <Table.Cell>
                                  {r.error ? <span style={{color:"red"}}>{r.error}</span> : r.value != null ? <strong>{formatInvoiceQuantity(r.value, language)} {r.unit || ((!r.energyType || r.energyType === "electricity") ? "kWh" : "")}</strong> : <span style={{color:"#aaa"}}>{t("not_detected") || "No detectado"}</span>}
                                  {!r.error && r.kwhUncertain && (
                                    <span title={t("invoice_value_review_hint")} style={{ marginLeft: "0.4rem", background: "#fff4e5", color: "#b35c00", borderRadius: "4px", padding: "1px 6px", fontSize: "0.72rem", fontWeight: 600, whiteSpace: "nowrap" }}>
                                      <Icon name="warning sign" style={{ margin: 0 }} /> {t("invoice_value_review")}
                                    </span>
                                  )}
                                  {!r.error && r.kwhSource === "ai" && (
                                    <span title={t("invoice_value_from_ai_hint")} style={{ marginLeft: "0.4rem", background: "#eef0fb", color: "#3b3f8f", borderRadius: "4px", padding: "1px 6px", fontSize: "0.72rem", fontWeight: 600 }}>
                                      IA
                                    </span>
                                  )}
                                </Table.Cell>
                                <Table.Cell>
                                  {r.error ? "—" : r.cost != null ? (
                                    <>
                                      <strong style={{ whiteSpace: "nowrap" }}>{invoiceCurrencySymbol(r.currency)} {formatInvoiceAmount(r.cost, r.currency, language)}</strong>
                                      {r.currency && (
                                        <span style={INVOICE_CURRENCY_BADGE_STYLE}>
                                          {r.currency}
                                        </span>
                                      )}
                                    </>
                                  ) : <span style={{color:"#aaa"}}>{t("not_detected") || "No detectado"}</span>}
                                </Table.Cell>
                                <Table.Cell style={{ width: "13em", minWidth: "13em" }}>
                                  {!r.error && (() => {
                                    const btnStyle = { padding: "0.35em 0.75em", lineHeight: 1, width: "100%", whiteSpace: "nowrap" };
                                    if (appliedIndexes.has(r._rowId)) {
                                      return (
                                        <Button size="mini" color="green" style={btnStyle} onClick={() => handleUnapplyInvoiceData(r)} title={t("unapply") || "Desaplicar"}>
                                          <Icon name="check" /> {t("applied") || "Aplicado"} <Icon name="times" style={{ marginLeft: "0.3em", marginRight: 0, opacity: 0.7 }} />
                                        </Button>
                                      );
                                    }

                                    const family = familyOf(r.energyType);
                                    const target = resolveTargetFields(r.energyType);

                                    // Tipo de energía detectado pero el campo no está activo en la
                                    // configuración del sitio: no hay dónde aplicarla.
                                    if (target.mode === "blocked") {
                                      return (
                                        <span style={{ fontSize: "0.78em", color: "#a05a2c" }} title={t("energy_type_field_not_configured") || "Campo no configurado para este sitio"}>
                                          <Icon name="ban" /> {t(target.valueField) || target.valueField}
                                        </span>
                                      );
                                    }

                                    // Combinada está desactivada y hay 2+ sub-usos activos a la vez
                                    // (doméstica+producción, o cogeneración/producción y
                                    // operaciones/montacargas): no hay forma de saber a cuál
                                    // corresponde la factura sin preguntar.
                                    if (target.mode === "choice") {
                                      const choice = sourceChoices[r._rowId];
                                      return (
                                        <div
                                          style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            gap: "0.4em",
                                            background: "#f0f4f9",
                                            border: "1px solid #d0dce8",
                                            borderRadius: "8px",
                                            padding: "0.5em",
                                          }}
                                        >
                                          <Dropdown
                                            icon={null}
                                            placeholder={t("select_source") || "¿A qué corresponde?"}
                                            selection
                                            options={target.choiceOptions.map((o) => ({ key: o.key, text: t(o.field) || o.field, value: o.key }))}
                                            value={choice || ""}
                                            onChange={(_, d) => setSourceChoices(prev => ({ ...prev, [r._rowId]: d.value }))}
                                            style={{ width: "100%", fontSize: "0.8em", minHeight: "auto" }}
                                          />
                                          <Button size="mini" color="teal" style={btnStyle} disabled={!choice} onClick={() => handleApplyInvoiceData(r)}>
                                            <Icon name="check" /> {t("apply") || "Aplicar"}
                                          </Button>
                                        </div>
                                      );
                                    }

                                    // Doméstica o Producción sin ambigüedad (la otra está inactiva):
                                    // aplicación directa, sin multi-medidor.
                                    if (target.mode === "direct") {
                                      return (
                                        <Button size="mini" color="teal" style={btnStyle} onClick={() => handleApplyInvoiceData(r)}>
                                          <Icon name="check" /> {t("apply") || "Aplicar"}
                                        </Button>
                                      );
                                    }

                                    const periodKey = r.period && r.year
                                      ? `${parseInt(r.year, 10)}-${PERIOD_NUM_TO_NAME[String(r.period)] || r.period}`
                                      : null;
                                    const periodConflict = periodKey && invoiceResults.some(
                                      other => other._rowId !== r._rowId &&
                                        appliedIndexes.has(other._rowId) &&
                                        other.period && other.year &&
                                        familyOf(other.energyType) === family &&
                                        `${parseInt(other.year, 10)}-${PERIOD_NUM_TO_NAME[String(other.period)] || other.period}` === periodKey
                                    );
                                    return periodConflict
                                      ? <div
                                          style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            gap: "0.4em",
                                            background: "#f0f4f9",
                                            border: "1px solid #d0dce8",
                                            borderRadius: "8px",
                                            padding: "0.5em",
                                          }}
                                        >
                                          <Dropdown
                                            icon={null}
                                            placeholder={t("meter_name") || "Nombre del medidor"}
                                            search
                                            selection
                                            allowAdditions
                                            additionLabel={`${t("add_new_meter") || "Nuevo medidor"}: `}
                                            options={existingMeterNames.map((name) => ({ key: name, text: name, value: name }))}
                                            value={meterNames[r._rowId] || ""}
                                            onAddItem={(_, d) => setExistingMeterNames((prev) => [...prev, d.value].sort())}
                                            onChange={(_, d) => setMeterNames(prev => ({ ...prev, [r._rowId]: d.value }))}
                                            style={{ width: "100%", fontSize: "0.8em", minHeight: "auto" }}
                                          />
                                          <Button size="mini" color="blue" style={btnStyle} onClick={() => handleApplyInvoiceData(r)}>
                                            <Icon name="plus" /> {t("add_as_meter_record") || "Agregar como registro"}
                                          </Button>
                                        </div>
                                      : <Button size="mini" color="teal" style={btnStyle} onClick={() => handleApplyInvoiceData(r)}>
                                          <Icon name="check" /> {t("apply") || "Aplicar"}
                                        </Button>;
                                  })()}
                                </Table.Cell>
                              </Table.Row>
                            ))}
                          </React.Fragment>
                        ))}
                      </Table.Body>
                    </Table>
                  );
                })()}
              </div>
            );
          })()}

          {applyWarning && (
            <Message warning size="small" style={{ marginTop: "0.75rem" }}>
              <Icon name="warning sign" />
              {applyWarning}
            </Message>
          )}

          <div ref={bulkSaveResultsRef} />
          {bulkSaveResults && (() => {
            const renderFileList = (items, color) => (
              <ul style={{ margin: "4px 0 0 16px", padding: 0, listStyle: "none" }}>
                {items.map((item, i) => (
                  <li key={i} style={{ fontSize: "0.82em", color: "#555", marginBottom: 2 }}>
                    <Icon name="file alternate outline" style={{ color }} />
                    <strong>{t(item.period)} {item.year}</strong>
                    {item.filename && <span style={{ marginLeft: 6, color: "#888" }}>— {item.filename}</span>}
                    {item.msg && <span style={{ marginLeft: 6, color: "#c0392b" }}>({item.msg})</span>}
                  </li>
                ))}
              </ul>
            );
            return (
              <Message
                success={bulkSaveResults.errors.length === 0 && bulkSaveResults.saved.length > 0}
                warning={bulkSaveResults.errors.length > 0 || bulkSaveResults.saved.length === 0}
                style={{ marginTop: "1rem" }}
              >
                <Message.Header>{t("bulk_save_result") || "Resultado del guardado"}</Message.Header>
                {bulkSaveResults.saved.length > 0 && (
                  <div style={{ marginTop: "0.5rem" }}>
                    <Icon name="check circle" color="green" />
                    <strong style={{ color: "#27ae60" }}>
                      {bulkSaveResults.saved.length} {t("bulk_saved_ok") || "guardados correctamente"}
                    </strong>
                    {renderFileList(bulkSaveResults.saved, "#27ae60")}
                  </div>
                )}
                {bulkSaveResults.skipped.length > 0 && (
                  <div style={{ marginTop: "0.5rem" }}>
                    <Icon name="warning sign" color="yellow" />
                    <strong style={{ color: "#e67e22" }}>
                      {bulkSaveResults.skipped.length} {t("bulk_skipped") || "omitidos (período ya existía)"}
                    </strong>
                    {renderFileList(bulkSaveResults.skipped, "#e67e22")}
                  </div>
                )}
                {bulkSaveResults.errors.length > 0 && (
                  <div style={{ marginTop: "0.5rem" }}>
                    <Icon name="times circle" color="red" />
                    <strong style={{ color: "#c0392b" }}>
                      {bulkSaveResults.errors.length} {t("bulk_errors") || "con error al guardar"}
                    </strong>
                    {renderFileList(bulkSaveResults.errors, "#c0392b")}
                  </div>
                )}
              </Message>
            );
          })()}
        </Modal.Content>
        <Modal.Actions>
          {!bulkSaveResults && appliedIndexes.size > 0 && (
            <Button
              primary
              onClick={handleSaveAllInvoiceData}
              loading={bulkSaveLoading}
              disabled={bulkSaveLoading}
            >
              <Icon name="save" /> {`${t("save_applied") || "Guardar"} (${appliedIndexes.size})`}
            </Button>
          )}
          <Button
            secondary
            onClick={() => {
              setShowInvoiceModal(false);
              setBulkSaveResults(null);
              setApplyWarning(null);
              if (bulkSaveResults?.saved?.length > 0) goBack();
            }}
            disabled={bulkSaveLoading}
          >
            <Icon name="close" /> {t("close") || "Cerrar"}
          </Button>
        </Modal.Actions>
      </Modal>
    </Form>

    {/* {showModalInt ? (
        <>
  <Modal
    open={showModalInt}
    onClose={() => setShowModalInt(false)}
    size="tiny"
    closeOnDimmerClick={false}
    closeOnEscape={false}
  >
    <Modal.Header>{titleModal}</Modal.Header>
    <Modal.Content>
      <Comments
        formik={formik}
        fieldName={fieldName}
        onClose={() => setShowModalInt(false)}
        user={user}
        t={t}
      />
    </Modal.Content>
    <Modal.Actions>
      <Button onClick={() => setShowModalInt(false)} secondary>
        {t("close")}
      </Button>
    </Modal.Actions>
  </Modal></> ): null} */}
  </>
  );
}

function InvoiceDropzone({ onFiles, loading, t, inputRef, onInputChange }) {
  const [isDragOver, setIsDragOver] = useState(false);

  const { getRootProps, getInputProps } = useDropzone({
    accept: { "application/pdf": [], "image/*": [], "text/csv": [], "application/vnd.ms-excel": [], "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [], "text/plain": [] },
    multiple: true,
    disabled: loading,
    noClick: true,
    noKeyboard: true,
    onDrop: (accepted) => { if (accepted.length > 0) onFiles(accepted); },
    onDragEnter: () => setIsDragOver(true),
    onDragLeave: () => setIsDragOver(false),
    onDropAccepted: () => setIsDragOver(false),
    onDropRejected: () => setIsDragOver(false),
  });

  return (
    <div
      {...getRootProps()}
      style={{
        border: `2px dashed ${isDragOver ? "#648EBC" : "#b0c4de"}`,
        borderRadius: "12px",
        padding: "2.5rem 1.5rem",
        minHeight: "260px",
        textAlign: "center",
        cursor: loading ? "not-allowed" : "pointer",
        background: isDragOver ? "#f0f6ff" : "#fafafa",
        transition: "all 0.2s ease",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: "1rem",
      }}
    >
      <input {...getInputProps()} />
      <input
        ref={inputRef}
        type="file"
        accept=".pdf,.jpg,.jpeg,.png,.webp,.csv,.xlsx,.xls,.txt"
        multiple
        style={{ display: "none" }}
        onChange={onInputChange}
      />
      {loading ? (
        <>
          <img
            src={`${process.env.PUBLIC_URL}/favicon.png`}
            alt="sustemia"
            className="invoice-dropzone-spinner"
          />
          <p style={{ color: "#648EBC", fontWeight: 600 }}>{t("processing")}</p>
        </>
      ) : (
        <>
          <Icon name="cloud upload" size="huge" color="blue" style={{ margin: 0 }} />
          <p style={{ margin: 0, fontSize: "1rem", fontWeight: 500, color: "#333" }}>
            {t("drag_drop_files")}
          </p>
          <p style={{ margin: 0, color: "#888", fontSize: "0.85rem" }}>o</p>
          <Button type="button" primary onClick={(e) => { e.stopPropagation(); inputRef.current?.click(); }}>
            <Icon name="folder open outline" />
            {t("select_files")}
          </Button>
          <p style={{ margin: 0, color: "#aaa", fontSize: "0.75rem" }}>
            {t("supported_formats")}
          </p>
        </>
      )}
    </div>
  );
}

function Comments({ formik, user, fieldName, onClose, t }) {
  const [comment, setComment] = useState("");

  const handleAddComment = () => {
    if (comment.trim().length > 0) {
      const reviews = [...(formik.values[fieldName].reviews || [])];

      reviews.push({
        comments: comment.trim(),
        date: new Date(),
        reviewer_user: user ? user._id : null,
      });

      formik.setFieldValue(`${fieldName}.reviews`, reviews);
      setComment("");
    }
  };

  const handleSaveComment = (id, editedContent) => {
    const reviews = [...formik.values[fieldName].reviews];
    reviews[id] = {
      ...reviews[id],
      comments: editedContent.trim(),
      date: new Date(),
    };
    formik.setFieldValue(`${fieldName}.reviews`, reviews);
  };

  const reviews = formik.values[fieldName]?.reviews || [];

  return (
    <CommentGroup minimal>
      <Header as="h4" dividing>{t("comments")}</Header>
      {reviews.map((review, index) => (
    
        <React.Fragment key={index}>
          <EditableComment
            id={index}
            author={
              review.reviewer_user
                ? review.reviewer_user === user._id
                  ? `${user.firstname} ${user.lastname}`
                  : `${review.reviewer_user.firstname} ${review.reviewer_user.lastname}`
                : ""
            }
            date={formatDateHourCompleted(review.date)}
            content={review.comments}
            onSave={handleSaveComment}
            active={review.reviewer_user === user._id}
            t={t}
          />
          <Divider fitted />    {console.log(review)}
        </React.Fragment>
      ))}


      {/* ✨ Form con preventDefault para evitar submit accidental */}
      <Form reply className="comments-reply-form" onSubmit={(e) => e.preventDefault()}>
        <Form.TextArea
          placeholder={t("write_a_comment")}
          rows={3}
          style={{ minHeight: 100 }}
          onChange={(_, data) => setComment(data.value)}
          value={comment}
        />

        <div style={{ display: "flex", gap: "1em", marginTop: "1em", justifyContent: "center" }}>
          <Button
            type="button" // importante para no disparar submit
            content="Añadir"
            primary
            size="small"
            style={{ minWidth: 100 }}
            onClick={handleAddComment}
          />
          <Button
            type="button" // importante para no disparar submit
            content={t("close")}
            secondary
            size="small"
            style={{ minWidth: 100 }}
            onClick={onClose}
          />
        </div>
      </Form>
    </CommentGroup>
  );
}

function EditableComment({ id, author, date, content, onSave, active, t }) {
  const [isEditing, setIsEditing] = useState(false);
  const [editedContent, setEditedContent] = useState(content);

  const handleChange = (e) => setEditedContent(e.target.value);
  const handleEdit = () => setIsEditing(true);
  const handleCancel = () => {
    setEditedContent(content);
    setIsEditing(false);
  };
  const handleSave = () => {
    if (editedContent.trim()) {
      onSave(id, editedContent);
      setIsEditing(false);
    }
  };

  const initials = author
    ? author.split(" ").map((n) => n[0]).join("").slice(0, 2).toUpperCase()
    : "?";

  return (
    <div style={{
      display: "flex",
      gap: "10px",
      padding: "10px 12px",
      borderRadius: "10px",
      backgroundColor: "#f4f6f9",
      marginBottom: "8px",
    }}>
      <div style={{
        width: "36px",
        height: "36px",
        borderRadius: "50%",
        backgroundColor: "#648EBC",
        color: "#fff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "13px",
        fontWeight: "700",
        flexShrink: 0,
      }}>
        {initials}
      </div>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ display: "flex", alignItems: "baseline", gap: "8px", marginBottom: "4px" }}>
          <span style={{ fontWeight: "700", fontSize: "13px", color: "#1A1C40" }}>{author}</span>
          <span style={{ fontSize: "11px", color: "#999" }}>{date}</span>
        </div>
        {isEditing ? (
          <Form reply>
            <Form.TextArea value={editedContent} onChange={handleChange} rows={3} />
            <div style={{ display: "flex", gap: "0.5rem", marginTop: "0.5rem", justifyContent: "center" }}>
              <Button type="button" icon="check" circular primary className="btn-comment-edit-action" onClick={handleSave} />
              <Button type="button" icon="times" circular secondary className="btn-comment-edit-action" onClick={handleCancel} />
            </div>
          </Form>
        ) : (
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: "8px" }}>
            <p style={{ margin: 0, fontSize: "13px", color: "#333", wordBreak: "break-word" }}>{content}</p>
            {active && (
              <Icon
                name="pencil"
                size="small"
                style={{ cursor: "pointer", color: "#aaa", flexShrink: 0, marginTop: "2px" }}
                onClick={handleEdit}
              />
            )}
          </div>
        )}
      </div>
    </div>
  );
}

function FileViewer(props) {
  const { fileName, fileUniqueName, handleRemove, t } = props;
  const [fileUrl, setFileUrl] = useState("");
  const [previewOpen, setPreviewOpen] = useState(false);

  useEffect(() => {
    if (fileName) {
      const url = energyFormController.getFileApi(fileUniqueName);
      setFileUrl(url);
    }
  }, [fileName]);

  const handleOpenPreview = (event) => {
    event.preventDefault();
    setPreviewOpen(true);
  };

  const handleClosePreview = (event) => {
    event.preventDefault(); // Previene el comportamiento predeterminado
    setPreviewOpen(false);
  };

  return (
    <>
      <List.Content floated="left">{fileName}</List.Content>
      <List.Content floated="right">
        {" "}
        <Button
          color="red"
          onClick={() => handleRemove(fileUniqueName)}
          icon="trash alternate"
        />
      </List.Content>
      {/* //<Button onClick={handleOpenPreview}> {fileName}</Button> */}
      <List.Content floated="right">
        <Modal
          onClose={handleClosePreview}
          onOpen={handleOpenPreview}
          open={previewOpen}
          trigger={
            <Button primary icon>
              <Icon name="eye" />
            </Button>
          }
        >
          <ModalHeader>{fileName}</ModalHeader>
          <ModalContent>
            {fileName &&
              (fileName.endsWith(".jpg") ||
                fileName.endsWith(".png") ||
                fileName.endsWith(".jpeg")) && (
                <Image
                  src={fileUrl}
                  alt="Vista previa"
                  style={{ maxWidth: "100%" }}
                />
              )}
            {fileName && fileName.endsWith(".pdf") && (
              <iframe
                src={fileUrl}
                title={t("preview")}
                style={{ width: "100%", height: "500px" }}
              />
            )}
          </ModalContent>
          <ModalActions>
            {/* <Button color="red" onClick={() => handleRemove(fileName)}>
            <Icon disabled name="trash alternate" /> Eliminar
          </Button> */}
            <Button color="black" onClick={handleClosePreview}>
              <Icon disabled name="close" />
              {t("close")}
            </Button>
          </ModalActions>
        </Modal>
      </List.Content>
    </>
  );
}

function FileUpload(props) {
  const { accessToken, data, field, newFiles, setNewFiles, t } = props;
  const [files, setFiles] = useState([]);
  const [filesView, setFilesView] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [openModal, setOpenModal] = useState(false); // Para controlar el estado del modal

  useEffect(() => {
    if (data.values[field].files) {
      setFilesView(data.values[field].files); // Construye la URL del archivo
    }
  }, [data]);

  const handleButtonClick = (event) => {
    event.preventDefault(); // Evita que el formulario se envíe
    const input = document.createElement("input");
    input.type = "file";
    input.multiple = true;
    input.onchange = handleFileChange;
    input.click();
  };

  // Maneja el cambio cuando se seleccionan archivos
  const handleFileChange = async (e) => {
    e.preventDefault(); // Evita que el formulario se envíe
    const selectedFiles = e.target.files;
    setNewFiles({ ...newFiles, [field]: Array.from(selectedFiles) });
    //data.setFieldValue(`${field}.files`,Array.from(selectedFiles))
    setFiles([...selectedFiles]);
  };

  // Función para cerrar el modal
  const closeModal = (event) => {
    event.preventDefault();
    setOpenModal(!openModal);
  };

  const handleRemoveFile = async (file) => {
    try {
      const updatedFiles = filesView.filter((f) => f.uniqueName !== file);
      setFilesView(updatedFiles);
      const response = await energyFormController.deleteFileApi(
        accessToken,
        file
      );
      //setMessage(response.message);
      removeFile(updatedFiles);
    } catch (error) {
      // setMessage('Error al elimianr el archivo');
    }
  };

  const removeFile = async (updatedFiles) => {
    data.setFieldValue(`${field}.files`, updatedFiles);
  };

  return (
    <>
      {/* Input para seleccionar los archivos */}
      {/* <Input
        type="file"
        multiple
        icon={"paperclip"}
        onChange={handleFileUpload}
      /> */}

      <Popup
        content={t("upload_file")}
        trigger={
          <Button
            default
            onClick={handleButtonClick}
            style={{ marginTop: "10px" }}
            color={files.length > 0 ? "green" : "grey"}
          >
            <img src={vector71Icon} alt="upload" style={{ width: 14, height: 14, filter: "brightness(0) invert(1)" }} />
          </Button>
        }
      />

      {/* Mensajes de éxito o error */}
      {successMessage && (
        <Message success>
          <Message.Header>Éxito</Message.Header>
          <p>{successMessage}</p>
        </Message>
      )}

      {errorMessage && (
        <Message error>
          <Message.Header>Error</Message.Header>
          <p>{errorMessage}</p>
        </Message>
      )}

      <Popup
        content={t("view_file")}
        trigger={
          <Button
            primary
            onClick={closeModal}
            style={{ marginTop: "10px" }}
          >
            <img src={viewIcon} alt="view" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
          </Button>
        }
      />
      {/* Modal para mostrar los archivos subidos */}
      <BasicModal show={openModal} close={closeModal} title="Archivos subidos" size="tiny">
          <List divided>
            {filesView.length > 0 && (
              <>
                <Header as="h4">Archivos existentes</Header>
                {filesView.map((filePath, index) => (
                  <List.Item key={index}>
                    <FileViewer
                      fileName={filePath.name}
                      fileUniqueName={filePath.uniqueName}
                      handleRemove={handleRemoveFile}
                      t={t}
                    />
                  </List.Item>
                ))}
              </>
            )}
            {newFiles[field] && newFiles[field].length > 0 && (
              <>
                <Header as="h4">Archivos nuevos (se guardarán al enviar)</Header>
                {newFiles[field].map((file, index) => (
                  <List.Item key={`new-${index}`}>
                    <List.Content floated="left">{file.name}</List.Content>
                    <List.Content floated="right">
                      <Button
                        color="blue"
                        onClick={() => window.open(URL.createObjectURL(file), '_blank')}
                        icon="eye"
                      />
                      <Button
                        color="red"
                        onClick={() => {
                          const updatedNewFiles = newFiles[field].filter((_, i) => i !== index);
                          setNewFiles({ ...newFiles, [field]: updatedNewFiles });
                        }}
                        icon="trash alternate"
                      />
                    </List.Content>
                  </List.Item>
                ))}
              </>
            )}
            {filesView.length === 0 && (!newFiles[field] || newFiles[field].length === 0) && (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "0.5em",
                  color: "#9e9e9e",
                  padding: "2em 0",
                }}
              >
                <Icon name="file outline" size="big" />
                <span>No se encontraron archivos subidos.</span>
              </div>
            )}
          </List>
          <div className="view-files-actions" style={{ display: 'flex', justifyContent: 'center', marginTop: '1.5em' }}>
            <Button secondary size="small" style={{ minWidth: 100 }} onClick={closeModal}>{t("close")}</Button>
          </div>
      </BasicModal>
    </>
  );
}

